// hideProductTour({ fromWhere, withLastStepNotify, skipGotoFocus, lastStepNotifySeen })

import React from 'react';
import notification from 'antd/lib/notification';
import message from 'antd/lib/message';
import Button from 'antd/lib/button';
import { Modal } from 'antd-mobile';

import {
  dualPedigreeMode,
  dualPedigreeLaunchOnDev,
  nodeWidth,
  nodeHeight,
  targetFocusMobileScale,
  targetFocusDesktopScale,
  targetFocusPedigreeIpadScale,
  targetFocusPedigreeIpadCenterX,
  targetFocusPedigreeIpadCenterY,
  targetFocusPedigreeMobilePhoneCenterX,
  targetFocusPedigreeMobilePhoneCenterY,
  zoomSpeedInMilisecs,
  numberOfZoomSteps,
  pauseMillisecB4Zoom,
  panSpeedInMilisecs,
  numOfStepsOnAnimatedPan,
  exitMobileFlipCardScale,
  zoomedAlltheWayOutForMobileScale,
  isDevelopment,
  midscale,
  translatedLabels,
  isRtl,
  imageBasePath,
  picDim,
  isSeinfeld,
  isStage,
  canvasSideMargin,
  autoFlipnode,
  autoLaunchflipcard,
  autoLaunchflippanel,
  autoLaunchflippanelThenClickRoone,
  autoFetchProfiles,
  debugWiderCatchForFetchProfiles,
  debugFetchPrunes,
  version,
  gitMessage,
  autoLaunchPedigreeCallout,
  fetchPrunesDelay,
  minimal,
  debugDiv,
  debugLocationHistory,
  autoClickNavigationNow,
  autoLaunchNavGotoListMobile,
  autoLaunchLegendListMobile,
  autoLaunchPrintCardMobile,
  autoClickPrintTreeIcon,
  autoClickPreferences,
  autoClickProductTourIcon,
  autoClickPrintTreeMobileIcon,
  firstCountNodeShiftX,
  firstCountOrWarningNodeShiftY,
  flipPanelWidth,
  presetObj,
  importCustomStylesFromServer,
  autoLaunchMoreMobile,
  autoLaunchDualPedigreeModal,
  targetDualPedigreeChartScale,
  targetDualPedigreeChartIpadScale,
  targetDualPedigreeChartAndroidTabletScale,
  targetDualPedigreePosX,
  targetDualPedigreePosY,
  maxZoom,
  minZoom,
  defaultFanChartStagePos
} from '../../library/constants';

import {
  makeArrayOfHalfValuesStartingWith,
  buildArrayOfScalesForZooming,
  isMobilePhone,
  isMobileTablet,
  isEmpty,
  isNodeWithinViewport,
  addEvent,
  getNodeFromNodeObjsWithPrId,
  buildSetPageProfilesObj,
  oddcasesWhereHeightIsDoubleWidth,
  doWhenReady,
  toUpper,
  breakIdsIntoChunks,
  convertObjToArray,
  simulate,
  screenCanShowModal,
  isAndroidPhone,
  getComputedDomValue,
  isAndroidTablet,
  debugStageCurrent,
  urlGet,
  // isPAD,
} from '../../library/calc';

import {
  NotificationModal,
} from './codesplitting';

import { data } from '../../version/dataVersion.js';
import AssembleTree from './1_assembletree';
import { sortBy } from 'lodash';

class Base extends AssembleTree {

  devAutoStart(){

    // window.callUpdateMatchCounts('56',{tm: 2, rm: 1, sm: 2, tmn: true})

    // setTimeout(() => {
    //   window.callReloadCanvasTree('52003', {prIdToTeleport:'52476', warnPublic:true})
    // }, 1000);


    if( isDevelopment && isRtl ){
      document.getElementsByTagName("HTML")[0].setAttribute("dir", "rtl");
    }


    if(debugDiv){

      document.getElementById("debugDiv").innerHTML += navigator.userAgent;
      document.getElementById("debugDiv").innerHTML += '';
      document.getElementById("debugDiv").innerHTML += 'inner width: ' + window.innerWidth + ' ';
      document.getElementById("debugDiv").innerHTML += 'inner height: ' + window.innerHeight + ' ';
      document.getElementById("debugDiv").innerHTML += 'screen width: ' + window.screen.width + ' ';
      document.getElementById("debugDiv").innerHTML += 'screen height: ' + window.screen.height + ' ';
      if(isAndroidPhone()) document.getElementById("debugDiv").innerHTML += '....isAndroidPhone: YES';

      // document.getElementById("debugDiv").addEventListener('click', (event) => {
      //   document.getElementById("debugDiv").innerHTML = '';
      // });
      // document.getElementById("debugDiv2").addEventListener('click', (event) => {
      //    window.miniCanvas.forceMiniStageToUpdate({showProgressIndicator: true});
      // });
      // document.getElementById("debugDiv2").style.cursor = 'pointer';
      // document.getElementById("debugDiv").style.display = 'block';
      // document.getElementById("debugDiv2").style.display = 'block';
      // document.getElementById("debugDiv").innerHTML = `ver: ${version}<br />`



    }


    if(autoLaunchPedigreeCallout){
      this.autoLaunchPedigreeCallout();
    }


    if(isDevelopment ){

      // this.highlight(29);
      // this.highlight(-11);
      // this.highlight(-18);
      // this.highlight(-14);


      // this.makeDesktopControlsVisible();

      // window.callSetReduxCanvasTopHeight(63, 400)

    }


    if(isDevelopment || isSeinfeld) {


      // setTimeout(() => {
      //   simulate({el: document.getElementById('mobileNavGotoList'), event: 'click'})
      // }, 2000);


        const node = 787
        const stateTreeIsVisable = () => {
          return autoLaunchDualPedigreeModal  && typeof(this.props.nodeObjs[node]) !== 'undefined' ;
        }

        const clickIt = () => {
          setTimeout(() => {

            this.showDualPedigreeModal({node: node})

          }, 2000);
        }

        doWhenReady({argument: '', condition: stateTreeIsVisable, callback: clickIt, attempts: {ongoing:0, end: 99999999}, fromWhere: 'devAutoStart'})


      if(autoClickPrintTreeMobileIcon && !this.props.isPedigree){


        const whenPrintTreeIcon = () => {
          return document.getElementById('printTreeIcon') != null;
        }

        const clickIt = () => {
          setTimeout(() => {

            simulate({el: document.getElementById('printTreeIcon'), event: 'click'});  // printTreeResolution Tweak

              setTimeout(() => {

                simulate({el: document.getElementById('createPDFButton'), event: 'click'});  // printTreeResolution Tweak

                  setTimeout(() => {

                    simulate({el: document.getElementById('createPDFButton'), event: 'click'});  // printTreeResolution Tweak

                  }, 3000);

              }, 3000);

          }, 2000);
        }

        doWhenReady({argument: '', condition: whenPrintTreeIcon, callback: clickIt, attempts: {ongoing:0, end: 99999999}, fromWhere: 'devAutoStart'})

      }

      if(autoClickPrintTreeIcon && !this.props.isPedigree){
        return // printTreeResolution Tweak

        const whenPrintTreeIcon = () => {
          return document.getElementById('printTreeIcon') != null;
        }

        const clickIt = () => {
          setTimeout(() => {

            simulate({el: document.getElementById('printTreeIcon'), event: 'click'});

            setTimeout(() => {

              simulate({el: document.getElementById('basicTreeCard'), event: 'click'});

            }, 600);
          }, 2000);
        }

        doWhenReady({argument: '', condition: whenPrintTreeIcon, callback: clickIt, attempts: {ongoing:0, end: 99999999}, fromWhere: 'devAutoStart'})

      }

      if(autoClickPreferences && !this.props.isPedigree){


        const whenpreferencesDiv = () => {
          return document.getElementById('preferences-icon') != null;
        }

        const clickIt = () => {
          setTimeout(() => {

            simulate({el: document.getElementById('preferences-icon'), event: 'click'});

          }, 2000);
        }

        doWhenReady({argument: '', condition: whenpreferencesDiv, callback: clickIt, attempts: {ongoing:0, end: 99999999}, fromWhere: 'devAutoStart'})

      }

      if(autoClickProductTourIcon && !this.props.isPedigree){


        const whenPrintTreeIcon = () => {
          return document.getElementById('productTourIcon') != null;
        }

        const clickIt = () => {


          setTimeout(() => {

   console.log(`%c autoClickProductTourIcon`, [
     'color: white',
     'background: green',
     'font-size: 14px',
     'border: 5px solid red',
     'padding: 10px',
     ].join(';'));

            simulate({el: document.getElementById('productTourIcon'), event: 'click'});

          }, 2000);
        }

        doWhenReady({argument: '', condition: whenPrintTreeIcon, callback: clickIt, attempts: {ongoing:0, end: 99999999}, fromWhere: 'devAutoStart'})

      }

      if(autoClickNavigationNow && !this.props.isPedigree){

        setTimeout(() => {
          simulate({el: document.getElementById('mapTabPull'), event: 'click'})
        }, 3000);



      }

        /*
         *
         *
         *  Decision Panel
         *
         *
         */


      if(isMobilePhone()) {

        if( autoLaunchflipcard ) this.autoLaunchFlipCard();
        if( autoLaunchMoreMobile ) this.autoLaunchMoreMobile();
        if( autoLaunchNavGotoListMobile ) this.autoLaunchNavGotoListMobile();
        if( autoLaunchLegendListMobile ) this.autoLaunchLegendListMobile();
        if( autoLaunchPrintCardMobile ) this.autoLaunchPrintCardMobile();


      } else {


        if(autoFetchProfiles){
          this.props.fetchProfiles({
            "newProfilesObj": {
              "40002817": "6232",
              "40002841": "6260",
              "40002857": "6276",
              "40002859": "6278",
              "40002945": "6322",
              "40002951": "6328",
              "40002952": "6329",
              "40002953": "6330",
              "40003025": "6394",
              "40003027": "6396",
              "40003028": "6397",
              "40003029": "6398",
              "40003030": "6399",
              "40003285": "6486",
              "40003288": "6470",
              "40003289": "6471",
              "40003291": "6473",
              "40003292": "6474",
              "40003293": "6475"
            }
          })
        }

        if(autoFlipnode && isDevelopment){
          this.onClickedNode(autoFlipnode);
        }

        let callback = () => {
        }

        if(autoLaunchflippanelThenClickRoone){

          callback = () => {

            setTimeout(() => {

              this.clickforImmediateFamily({
                "nodeObj": {
                  "prId": "79533",
                  "pr_id": "79533",
                  "n": 303,
                  "nm": "Roone Pinkney Arledge, Sr.",
                  "g": "m",
                  "img": {
                    "type": "placeholder",
                    "src": "/canvas-tree/imgs/no_photo_m.gif"
                  },
                  "fn": "Roone",
                  "ln": "Arledge",
                  "a": 1,
                  "e": 1,
                  "dateAlive": "",
                  "marriageId": "79520"
                },
                "doWhatToFlipNodeCrumbs": "add",
                "immediateFamVersion": "flipPanel"
              })
                  setTimeout(() => {

                                this.fetchResolveAndPopModal({prId: 79533});
                  }, 1000);

            }, 2000);


          }


        }

        if( autoLaunchflippanel ) this.autoLaunchFlipPanel({callback});

      }



/*
      this.setMoveDecisionPanelPos({
        "left": 660.0999999999999,
        "top": 285.2
      })

      this.setAddExistObj({
        "floater_profile_id": "38885",
        "focusPrid": "13038",
        "dropOnPrId": "38885",
        "floaterGender": "m"
      })


      this.setMoveDecisionPanelVisible(true);
*/

    }

  }

  bindStageEvents(){


    /*

        this.stage.current.container().style.cursor = 'pointer';
        this.stage.current.container().addEventListener('click', (e) => {
          console.log('stage/addEventListener/click');
        });


     */

    // this.stage = this.refs.stage.getStage();
    // this.stage.cache();
    window.thisStage = this.stage.current.container()
    this.stage.current.container().style.cursor = 'move';
    if (( !dualPedigreeMode && !dualPedigreeLaunchOnDev ) || dualPedigreeLaunchOnDev ){
      this.stage.current.container().style.cursor = 'pointer';
      this.stage.current.draggable(true);
    }

    this.stage.current.container().addEventListener('click', (e) => {

      if( dualPedigreeMode || dualPedigreeLaunchOnDev) return;

      this.setKeyPressEnabled(true);

      if(!this.stageCanBeClickedTouchedHovered) return;

      if(isMobilePhone() && !isDevelopment) window.closeMenu();  // closes mobile preferences

      this.clearAllAnimations({fromWhere: 'clicking stage'});

      this.cleanUp({closePedigreeAddbox: true});

      this.hideMatchBubble();

      this.hideProductTour({fromWhere: 'W', withLastStepNotify: true});

      if(!this.state.flipPanelOpened &&
         !this.matchBubbleAppears &&
         !this.flipPanelOpenAfterAnimateComplete &&
         this.stageClickCanZoomStep &&
         !this.props.isPedigree
        ) {

        return;
      }

      if(this.stageClickCanCloseFlipPanel) {
        this.stageClickCanCloseFlipPanel = false;
        this.toggleFlipPanel({close: true, from: 'stageClickCanCloseFlipPanel'});
        return;
      }

    });

  }

  debugStagePos(){ return;

    this.refs.scaleInput.value = this.stage.current.scaleX();
    this.refs.stageLeftInput.value = Math.round(this.stage.current.position().x / this.stage.current.scaleX()) * -1;
    this.refs.stageTopInput.value = Math.round(this.stage.current.position().y/ this.stage.current.scaleX())* -1;
    this.refs.stageRightInput.value = Math.round(this.stage.current.position().x + (this.props.canvasWidth / this.stage.current.scaleX()));
    this.refs.stageBottomInput.value = Math.round(this.stage.current.position().y + (this.props.canvasHeight / this.stage.current.scaleX()));
    this.refs.mouseX.value = ( typeof(this.stage.getPointerPosition()) !== 'undefined' ? this.stage.getPointerPosition().x : null);
    this.refs.mouseY.value = ( typeof(this.stage.getPointerPosition()) !== 'undefined' ? this.stage.getPointerPosition().y : null);
  }

  isZoomingIn(){
    if(this.redraw_scaleX_compare_end_value > this.redraw_scaleX_compare_start_value){
      this.isZooming = true;
      return true;
    } else{
      this.isZooming = false;
      return false;
    }
  }

  setViewPortHook(){

    // console.log('++++++++++++++++++++ REDUX STORE VIEWPORT UPDATE ');
    const { setViewport } = this.props;
    if(typeof(setViewport) !== 'function') return;

    if (!this.stage.current) {
      console.warn('Stage is not available in setViewPortHook.');
      return;
    }

    const left = Math.round(this.stage.current.position().x / this.stage.current.scaleX()) * -1;
    const top = Math.round(this.stage.current.position().y/ this.stage.current.scaleX())* -1;
    const scaledWidth = this.props.canvasWidth / this.stage.current.scaleX();
    const scaledHeight = this.props.canvasHeight / this.stage.current.scaleX();
    const right = left + scaledWidth;
    const bottom = top + scaledHeight;

    // document.getElementById("debugDiv4").innerHTML = `${top}:`;
    // document.getElementById("debugDiv3").innerHTML = `${right}:`;
    // document.getElementById("debugDiv2").innerHTML = `${bottom}:`;
    // document.getElementById("debugDiv1").innerHTML = `${left}:`;

    // document.getElementById("debugDiv5").innerHTML = `w: ${window.innerWidth}:`;
    // document.getElementById("debugDiv4").innerHTML = `h: ${window.innerHeight}:`;
    // document.getElementById("debugDiv3").innerHTML = `${right}:`;
    // document.getElementById("debugDiv2").innerHTML = `${bottom}:`;
    // document.getElementById("debugDiv1").innerHTML = `${left}:`;

    setViewport({top, right, bottom, left});

  }

  redraw({
    callback,
    clickedImmediateFamily,
    releaseQueueOfFetchedProfilesData,
    callbackFetchResolveAndPopModal,
    skipScrollTo,
    skipAdjustDragContainerPosition,
    skipUpdatePreviousTouchX,
    inviteCallback,
    showAddMenuCallback,
    openEditCardCallback,
    panToNodeCallback4Mobile,
    zoomOutFromMobileFlipCardCallback,
    callbackAfterGotoHashNode,
  }){

    this.visitedCount++; this.visited['redraw'] = this.visitedCount;

    if(isDevelopment) this.debugStagePos();

    if( typeof(window.forceHideMoreList)  !== 'undefined' && typeof(window.forceHideMoreList) === 'function') window.forceHideMoreList();

    if(!this.redraw_upon_zoom_comparison_initialized){
      this.redraw_upon_zoom_comparison_initialized = true;

        const fromWhere = 'redraw';
        const logExceptionAndRun = debugStageCurrent(function(stageCurrent) { // exceptions tweak
          this.redraw_scaleX_compare_start_value = stageCurrent.scaleX();
        }, fromWhere).bind(this);

        logExceptionAndRun();

    }

    const redrawFunc = () => {
      this.redraw_upon_zoom_comparison_initialized = false;

      if (this.stage && this.stage.current) {
        this.redraw_scaleX_compare_end_value = this.stage.current.scaleX();
      } else {
        console.error('this.stage.current is not initialized');
      }

      if( this.isZoomingIn() ) return;

      this.setViewPortHook();

      const { newProfilesObj, newPrunesObj } = this.gatherNodesToFetchMoreData({all: false,});

      this.releaseQueueFetchedProfilesData(); // Releasing PIDs outside viewport

      const callbackAllowComponentUpdate = ()=>{

        this.hideProgressIndicator();

      }


      if(typeof(callbackFetchResolveAndPopModal) !== 'undefined' ) callbackFetchResolveAndPopModal();
      if(typeof(showAddMenuCallback) !== 'undefined' ) showAddMenuCallback();
      if(typeof(openEditCardCallback) !== 'undefined' ) openEditCardCallback();
      if(typeof(inviteCallback) !== 'undefined' ) inviteCallback();
      if(typeof(panToNodeCallback4Mobile) !== 'undefined' ) panToNodeCallback4Mobile();
      if(typeof(zoomOutFromMobileFlipCardCallback) !== 'undefined' ) zoomOutFromMobileFlipCardCallback();
      if(typeof(callbackAfterGotoHashNode) !== 'undefined' ) callbackAfterGotoHashNode();

      this.fetchIt({
          newProfilesObj,
          newPrunesObj,
          callback,
          callbackAllowComponentUpdate,
          releaseQueueOfFetchedProfilesData: true, // Releasing PIDs inside viewport
      });

      setTimeout(() => {
        if(!isEmpty( newProfilesObj )){
          this.releaseForDelayedFetches();
        }
      }, 2000);

      if(typeof(this.props.viewPortSides) !== 'undefined' && !this.props.isPedigree){ // Fetch Wider Net
        const percentOfViewPort = 1;
        const scaledWiderNet = ((this.props.canvasWidth / this.stage.current.scaleX()) * percentOfViewPort);
        const {newProfilesObj, newPrunesObj} = this.gatherNodesToFetchMoreData({all: false,scaledWiderNet});
        if(debugWiderCatchForFetchProfiles) console.log('<<<<<<  fetchWiderNet >>>>>>');
        this.fetchIt({
            newProfilesObj,
            newPrunesObj,
            releaseQueueOfFetchedProfilesData, // passed from panAnimate...
            callback: undefined,
        });
      }
      setTimeout(() => {
        if(typeof(skipScrollTo) === 'undefined' ) skipScrollTo = true;
        if(typeof(window.dragMiniMapContainer) !== 'undefined' &&
          this.state.navigationPanelIsUp &&
          this.state.mapNavTabActive
        ){
          window.dragMiniMapContainer.adjustDragContainerPosition({
            skipScrollTo,
            skipAdjustDragContainerPosition,
            skipUpdatePreviousTouchX
          });}
      }, 400);

    }

    clearTimeout(this.redrawTimeOut);
    this.redrawTimeOut = setTimeout(redrawFunc, 100);

    if( typeof(clickedImmediateFamily) !== 'undefined' ){
       setTimeout(redrawFunc, 1000);
    }
  }

  fetchPrunesOnlyAfterDelay({newPrunesObj, postfetch, rightAway}){
    if(isDevelopment ) return;
    clearTimeout( this.fetchPruneTimeout );
    if( debugFetchPrunes ) console.log('<<< Resetting fetchPruneTimeout');
    this.fetchPruneTimeout = setTimeout(() => {
      if( debugFetchPrunes ) console.log('<<< Fetching after ',fetchPrunesDelay,' millisecs');
      if(typeof(this.props.fetchPrunes) !== 'function') return;
      this.props.fetchPrunes({newPrunesObj, postfetch, fromWhere: 'fetchPrunesOnlyAfterDelay'});
    }, fetchPrunesDelay);
    if(typeof(rightAway) !== 'undefined' && rightAway ){
      if(typeof(this.props.fetchPrunes) !== 'function') return;
      this.props.fetchPrunes({newPrunesObj, postfetch, fromWhere: 'fetchPrunesOnlyAfterDelay'});
    }
  }

  releaseForDelayedFetches(){
    const numOfAttempts = 15;
    const miliSecEachTime = 2500;
    this.countReleases = 0;
    this.releaseQueueTimer = undefined;
    clearTimeout( this.releaseQueueTimer );
    const attemptReleasingQueueTillEmpty = () => {

      this.countReleases++;
      if( debugWiderCatchForFetchProfiles ) console.log(`====== attemptReleasingQueue `, this.countReleases);

      this.releaseQueueTimer = setTimeout( attemptReleasingQueueTillEmpty, miliSecEachTime );

      const { newProfilesObj } = this.gatherNodesToFetchMoreData({all: false,});

      if(this.countReleases >= numOfAttempts || isEmpty( newProfilesObj )){
        if( debugWiderCatchForFetchProfiles ) console.log(`====== clearTimeout `, this.countReleases);
        this.countReleases = 0;

        if( this.isProductTourWithFirstMaleGhostAndStartStepAtOne && !this.productTourStepLaunchAfterFetch){
          this.showProductTourForFirstMaleGhostAndStartStepAtOne({fromWhere: 'releaseForDelayedFetches'})
          this.productTourStepLaunchAfterFetch = true;
        }

        clearTimeout( this.releaseQueueTimer );
        return;
      }

      if( debugWiderCatchForFetchProfiles ) console.log(`====== releaseQueue`, this.countReleases);
      this.releaseQueueFetchedProfilesData();

    }

    if( this.countReleases === 0) attemptReleasingQueueTillEmpty();
  }

  fetchEveryProfile(){
    const { newProfilesObj } = this.gatherNodesToFetchMoreData({all: true,});

    if(isEmpty( newProfilesObj ) && !this.state.allProfilesFetched){

      this.refreshGotoList();
      this.setState({
        allProfilesFetched: true
      })

    } else {

      this.fetchIt({
          setAllProfilesIsFetched: ()=>{

            this.setState({
              allProfilesFetched: true
            })
            this.applyAlternateColorShadingToNavigationGotoCols({going: -1})
          },
          newProfilesObj,
          releaseQueueOfFetchedProfilesData: true,
          callbackSetProgressBar: (percentLoadedOfFetchProfiles)=>{
            if(typeof(this.props.setProgressLoaded) !== 'undefined' ){
              console.log(`percentLoadedOfFetchProfiles: `, percentLoadedOfFetchProfiles);
              this.props.setProgressLoaded(percentLoadedOfFetchProfiles);
            }
          },
      });

    }

  }

  countProfiles(){

    let nodeObjsArray = convertObjToArray({obj: this.props.nodeObjs});

    console.log(`nodeObjsArray.length: `, nodeObjsArray.length);

    const nodeObjsArrayB = nodeObjsArray.filter((nodeObj)=>{
      return  typeof(nodeObj.nm) !== 'undefined' &&
              nodeObj.nm !== '' &&
              nodeObj.nt !== 'ghost'
    })

    console.log(`nodeObjsArrayB.length: `, nodeObjsArrayB.length);

  }

  gatherNodesToFetchMoreData({ all, scaledWiderNet, printViewPortSides }){
    const { nodeObjs } = this.props;
    let { viewPortSides } = this.props;

    // console.log(`{nodeObjs, viewPortSides}: `, JSON.stringify({nodeObjs, viewPortSides}, null, 2));

    if( typeof(printViewPortSides) !== 'undefined' ) viewPortSides = printViewPortSides;

    if(typeof(scaledWiderNet) !== 'undefined'){
    }

    let viewPortSidesAdapted = {...viewPortSides};

    if(typeof(scaledWiderNet) !== 'undefined'){
      viewPortSidesAdapted = {
        left: viewPortSides.left - scaledWiderNet,
        right: viewPortSides.right + scaledWiderNet
      }
      if(debugWiderCatchForFetchProfiles) {
        console.log(`viewport: `, JSON.stringify({left: parseInt(viewPortSides.left, 10), right: parseInt(viewPortSides.right, 10)}, null, 2));
        console.log(`scaledWiderNet: `, scaledWiderNet);
        console.log(`viewPortSidesAdapted: `, JSON.stringify({left:parseInt(viewPortSidesAdapted.left, 10), right: parseInt(viewPortSidesAdapted.right, 10)}, null, 2));
      }
    }

    let newProfilesObj = {};
    let newPrunesObj = {};
    for (let n in nodeObjs) {
      var nodeObj = nodeObjs[n];
      const tempViewportBuffer =  100;
      if( !all &&
          typeof(nodeObj) !== 'undefined' &&
          this.nodeNeedsFetchProfiles(nodeObj) &&
          isNodeWithinViewport( { nodeObj, viewPortSides: viewPortSidesAdapted, viewPortBuffer: tempViewportBuffer })) {
        newProfilesObj[nodeObj.pid] = n;
      };

      if( all ){
        if(this.nodeNeedsFetchProfiles(nodeObj)){
            newProfilesObj[nodeObj.pid] = n;
        }
      }

      if( typeof(nodeObj) !== 'undefined' && nodeObj.p === '+' && isNodeWithinViewport( { nodeObj, viewPortSides, viewPortBuffer: tempViewportBuffer })) {
        if( debugFetchPrunes ) console.log('..target pid: ' , nodeObj.pid);
        newPrunesObj[nodeObj.pid] = n;
      };

    }


    if( all ){

    /*
      *
      *
      *
      *
      *  Case where tree is already small and all names have been fetched.
      *
      *
      *
     */

      const pids = Object.keys(newProfilesObj);
      if( pids.length === 0){
          // console.log('All profiles fetched for this small tree');
          setTimeout(() => {

            this.setState({
              allProfilesFetched: true
            })
          }, 1000);
          this.applyAlternateColorShadingToNavigationGotoCols({going: -1})
      }
    }

    // console.log(`{newProfilesObj, newPrunesObj}: `, JSON.stringify({newProfilesObj, newPrunesObj}, null, 2));

    return {newProfilesObj, newPrunesObj};
  }

  nodeNeedsFetchProfiles(nodeObj){
    return  typeof(nodeObj.nn) === 'undefined' &&
            typeof(nodeObj.nvp) === 'undefined' &&
            nodeObj.nt !== 'ghost'
  }

  fetchIt({
    setAllProfilesIsFetched,
    newProfilesObj,
    newPrunesObj,
    callback,
    releaseQueueOfFetchedProfilesData,
    callbackAllowComponentUpdate,
    callbackSetProgressBar,
  }){

      this.visitedCount++; this.visited['fetchIt'] = this.visitedCount;

      if( !isEmpty(newProfilesObj)){

        const postfetch = () => {
          if( !isEmpty(newPrunesObj)){
            const postfetch = ({ firstNodeWithPrune }) => {
              // console.log(`firstNodeWithPrune: `, firstNodeWithPrune);
              if(typeof(firstNodeWithPrune) !== 'undefined' ){
                // console.log('postfetch fetchPrunesOnlyAfterDelay');
                this.setState({
                  firstNodeWithPrune
                });
              }
              this.hideProgressIndicator();
            };
            if(!this.props.isPedigree){
              if( debugFetchPrunes ) {
                console.log('***** fetchPrunes Delay ');
              }

              this.fetchPrunesOnlyAfterDelay({newPrunesObj, postfetch})
            }
          } else{
            this.hideProgressIndicator();
          }

        };

        if(this.props.isPedigree) {
          postfetch();
        } else {

          if(this.requestFetchForAllProfiles) return;
          if(typeof(setAllProfilesIsFetched) === 'function' ){
            this.requestFetchForAllProfiles = true;
          }

          if(!isDevelopment) {
            this.props.fetchProfiles({
              newProfilesObj,
              postfetch,
              releaseQueueOfFetchedProfilesData,
              setAllProfilesIsFetched,
              callbackAllowComponentUpdate,
              callbackSetProgressBar,
            });
          }
        }

      } else {

        if( this.isProductTourWithFirstMaleGhostAndStartStepAtOne && !this.productTourStepLaunchAfterFetch){
          this.showProductTourForFirstMaleGhostAndStartStepAtOne({fromWhere: 'No more fetchIt'});
          this.productTourStepLaunchAfterFetch = true;
        }

        if(debugWiderCatchForFetchProfiles) console.log('fetched profiles for this batch already.');

        if( isEmpty(newPrunesObj)){
          this.hideProgressIndicator();
        } else{
          const postfetch = ({ firstNodeWithPrune }) => {
            // console.log(`firstNodeWithPrune: `, firstNodeWithPrune);
            if(typeof(firstNodeWithPrune) !== 'undefined' ){
              // console.log('postfetch fetchPrunesOnlyAfterDelay');
              this.setState({
                firstNodeWithPrune
              });
            }
            this.hideProgressIndicator();
          };
          if(!this.props.isPedigree){
            if( debugFetchPrunes ) {
              console.log('***** fetchPrunes rightAway ');
            }

            this.fetchPrunesOnlyAfterDelay({newPrunesObj, postfetch, rightAway: true})
          }
        }

      }

      if(typeof(callback) !== 'undefined'){
        // console.log(`callback: `, callback);
        // console.trace('refactor');
        callback();
      }

  }

  buildRefetchProfilesObj({prIds}){

    const nodeObjs = this.props.nodeObjs;

    let newProfilesObj = {};
    for (let n in nodeObjs) {
      var nodeObj = nodeObjs[n];
      if( typeof(nodeObj) !== 'undefined' && prIds.includes(nodeObj.prId)){
            newProfilesObj[nodeObj.pid] = n;
      }
    }
    return newProfilesObj;

  }

  isClearingCalledTooMuch({fromWhere}){
    const throttleMilisec = 300
    if(!this.ok2clear){
      // console.log('******* clearing too much. clear request ignored from: ' + fromWhere);
      return true;
    } else{
      this.ok2clear = false;
      // console.log('** delaying when can be cleared from: ' + fromWhere);
      setTimeout(() => {
        // console.log('******* ok to be cleared now. *********');
        this.ok2clear = true;
      }, throttleMilisec);
      return false;
    }
  }

  cleanUp({
    closePedigreeAddbox,
    skipDismissNotification,
    skipMoveDecisionPanelVisible,
  }){
    clearTimeout(this.cleanMoveTimeOut);
    this.cleanMoveTimeOut = setTimeout(() => {
      if( this.state.nodeShownInToolTip !== null ) this.hideToolTip();
      if(typeof(skipMoveDecisionPanelVisible) === 'undefined' && this.state.moveDecisionPanelVisible) this.setMoveDecisionPanelVisible(false);
      if(typeof(skipDismissNotification) === 'undefined') this.destroyAtomNotification({all:true, fromWhere: 'cleanUp'});
      if( this.state.showMoveHelp ) this.setShowMoveHelp(false);
      this.unOpacityFloaters();
      this.unhighlight();
      if(this.props.isPedigree && closePedigreeAddbox) this.setPedigreeAddbox({visible:false});
    }, 500);

  }

  clearAllAnimations({fromWhere}){
    if(this.isClearingCalledTooMuch({fromWhere})) return;
    // console.log('** clearing all animations from: ' + fromWhere);
    clearInterval(this.panAnimateTimeInterval);
    clearInterval(this.moveVelocityTimeInterval);
    clearInterval(this.zoomOutTimeInterval);
    this.clearAllZoomInstances();

  }

  clearAllZoomInstances(){
    while( this.zoomQueueArray.length > 0){
      clearInterval(this.zoomQueueArray.pop());
    }
  }

  calcNewStageCenterNodePos(){

    this.visitedCount++; this.visited['calcNewStageCenterNodePos'] = this.visitedCount;
    const fromWhere = 'calcNewStageCenterNodePos';
    const logExceptionAndRun = debugStageCurrent(function(stageCurrent) { // exceptions tweak

      const scale = stageCurrent.scaleX();
      const scaledStageLeft = stageCurrent.x() / scale;
      const scaledStageTop = stageCurrent.y() / scale;
      const distanceToScaledNodeLeft = ( (this.props.canvasWidth / 2)/ scale) - ((nodeWidth/ 2) + 2 / scale);
      const distanceToScaledNodeTop = ( (this.props.canvasHeight/ 2)/ scale) - ((nodeHeight/ 2) + 2 / scale);
      this.stageCenteredNodePosX = -1 * scaledStageLeft + distanceToScaledNodeLeft;
      this.stageCenteredNodePosY = -1 * scaledStageTop + distanceToScaledNodeTop;

      // console.log(`:>`, JSON.stringify({stageCenteredNodePosX: this.stageCenteredNodePosX, stageCenteredNodePosY: this.stageCenteredNodePosY}, null, 2));

    }, fromWhere).bind(this);

    logExceptionAndRun();
  }

  getCurStagePos(){

    this.visitedCount++; this.visited['getCurStagePos'] = this.visitedCount;

    const scale = this.stage.current.scaleX();

    return {
      x: -1 * scale *  (this.stageCenteredNodePosX + (nodeWidth / 2)) + ( this.props.canvasWidth / 2),
      y: -1 * scale *  (this.stageCenteredNodePosY + (nodeHeight / 2)) + ( this.props.canvasHeight / 2)
    };

  }

  getNodeStagePos({node, yShift = 0, xShift = 0, fromWhere}){
    this.visitedCount++; this.visited['getNodeStagePos'] = this.visitedCount;
    return {
      x: (-1 * this.stage.current.scaleX() *  (this.nodeObjs[node].left + (nodeWidth / 2)) + ( this.props.canvasWidth / 2)) + xShift,
      y: (-1 * this.stage.current.scaleY() *  (this.nodeObjs[node].top + (nodeHeight / 2)) + ( this.props.canvasHeight / 2)) + yShift
    };
  }

  velocityMove(axis, direction, scaledChangeInDist, changeInTime){


    this.visitedCount++; this.visited['velocityMove'] = this.visitedCount;

    /*
      Shorter time during touches mean larger maxPan ... or momentum moves faster
    */

    if(this.tooMuchVelocityRequest()) return;
    if(this.state.showInviteModal) return;

    this.hideProductTour({fromWhere: 'U', withLastStepNotify: true});
    this.cleanUp({closePedigreeAddbox: true});
    this.unsetFirstTreeMatchCountNotify();
    this.unsetFirstRecordMatchCountNotify();
    if( typeof(window.forceHideMoreList) !== 'undefined' ) window.forceHideMoreList();

    const verticalMaxPan = 30;
    const horizontalMaxPan = 60;

    const panSpeedInMilisecs = 5;
    const defaultMaxPan = ( axis === 'horizontal' ? horizontalMaxPan: verticalMaxPan);
    let maxPan = Math.round(((defaultMaxPan/changeInTime) * 100) );

    const scale = ( isMobilePhone() ? this.stage.current.scaleX(): 1 );
    maxPan = Math.round(maxPan * scale);

    scaledChangeInDist = ( scaledChangeInDist > maxPan ? maxPan: scaledChangeInDist);
    if(this.props.chartType === 'fan') scaledChangeInDist = 10;
    let distance = scaledChangeInDist * direction;

    this.clearAllAnimations({fromWhere: 'velocity move'});

    let x = 0; x = ( axis ==='horizontal' ? distance: 0);
    let y = 0; y = ( axis ==='vertical' ? distance: 0);

    this.moveCoordinates = {x,y};

    if(distance === 0) return;  // BUG FIX FOR MOMENTUM KEPT GOING ON MOBILE

    this.moveVelocityTimeInterval = setInterval(()=>{
      if(direction === 1) distance--;
      else distance++;
      if (this.stage.current) {
          this.stage.current.move(this.moveCoordinates);
      } else {
          console.error("Attempted to call move on undefined this.stage.current");
      }
      this.stage.current.batchDraw();
      if(distance === 0 || distance > scaledChangeInDist) {
        clearInterval(this.moveVelocityTimeInterval);
        this.calcNewStageCenterNodePos();
        this.redraw({});
      }
    }, panSpeedInMilisecs);
  }

  delayStageClickCanZoomStep(){
    this.stageClickCanZoomStep = false;
    setTimeout(() => {
      this.stageClickCanZoomStep = true;
    }, 700);
  }

  animateThroughCycleNodes(fromNode, cyclemaster){

    this.delayStageClickCanZoomStep();
    const cidsArr = this.nodeObjs[cyclemaster].cidsArr;
    const cidsLength = this.nodeObjs[cyclemaster].cidsLength;

    let idx = cidsArr.indexOf(parseInt(fromNode, 10));
    let targetNode = null;
    if( idx + 1 === cidsLength){
      targetNode = cidsArr[0];
    } else{
      targetNode = cidsArr[idx + 1];
    }

    /*
      The following in place to avoid rapid fire clicking of focus button setting off pan animation
    */

    clearTimeout(this.gotoTargetNodeTimeout);

    this.gotoTargetNodeTimeout = setTimeout(() => {
      this.panAnimateToNode({node: targetNode, releaseQueueOfFetchedProfilesData: true});
    }, 500);
  }

  gotoFurthestNode({whichSide}){
    console.log(`this.farthestRightNode: `, this.farthestRightNode);
    const releaseQueueOfFetchedProfilesData = true;
    this.panAnimateToNode({
      node: whichSide === 'left' ? this.farthestLeftNode: this.farthestRightNode,
      releaseQueueOfFetchedProfilesData,
    });

  }

  gotoHashNode({node, callback, callbackFetchResolveAndPopModal}){
    const releaseQueueOfFetchedProfilesData = true;
    const callbackAfterGotoHashNode = () => {
      this.panAnimateToNode({node, releaseQueueOfFetchedProfilesData});
    }

    if( screenCanShowModal({minWidth:900})){
      this.panAnimateToNode({
        node,
        callbackFetchResolveAndPopModal,
        releaseQueueOfFetchedProfilesData,
      });
    } else if (isMobilePhone()) {
      this.zoomOutFromMobileFlipCard({
        node,
        callbackAfterGotoHashNode,
      });
    }

  }

  gotoHashNode_old({node, callback, callbackFetchResolveAndPopModal}){
    const releaseQueueOfFetchedProfilesData = true;
    const callbackAfterGotoHashNode = () => {
      this.panAnimateToNode({node, releaseQueueOfFetchedProfilesData});
    }
    if(isMobilePhone()) {
      this.zoomOutFromMobileFlipCard({
        node,
        callbackAfterGotoHashNode,
      });
    } else{
      this.panAnimateToNode({
        node,
        callbackFetchResolveAndPopModal,
        releaseQueueOfFetchedProfilesData,
      });
    }

  }

  gotoFocusNode({openFlipPanelForFocus, hasFirstTreeMatchCountNode, hasFirstRecordMatchCountNode, hasNodeForPublicWarning, callback, fromWhere}){
    this.visitedCount++; this.visited['gotoFocusNode'] = this.visitedCount;

    let node = this.props.focusNode;

    const nodeFocused = {
      'node': this.props.focusNode,
      'name': this.nodeObjs[this.props.focusNode].nm,
      'prId': this.nodeObjs[this.props.focusNode].prId,
    }

    this.debugOrder++;
    this.debugObj['focusNode'] = {order: this.debugOrder, nodeFocused};


    if(typeof(hasFirstTreeMatchCountNode) !== 'undefined' ){
      node = this.props.firstTreeMatchCountNode;
    }

    if(typeof(hasFirstRecordMatchCountNode) !== 'undefined' ){
      node = this.props.firstRecordMatchCountNode;
    }

    if(typeof(hasNodeForPublicWarning) !== 'undefined' ){

      node = getNodeFromNodeObjsWithPrId({nodeObjs: this.nodeObjs, prId: this.state.prIdForWarning, fromWhere: 'zoomAnimateToNode'});

    }

    this.cleanUp({closePedigreeAddbox: true});

    /*
      The following in place to avoid rapid fire clicking of focus button setting off pan animation
    */

    clearTimeout(this.gotoFocusNodeTimeout);

    this.gotoFocusNodeTimeout = setTimeout(() => {

      const panToNodeCallback4Mobile = ()=>{
       if(this.props.isPedigree){ this.teleportToPedigreeCenter({node, hasFirstTreeMatchCountNode, hasFirstRecordMatchCountNode, hasNodeForPublicWarning, callback, fromWhere:'panToNodeCallback4Mobile'});}
       else {
        this.panAnimateToNode({node, hasFirstTreeMatchCountNode, hasFirstRecordMatchCountNode, hasNodeForPublicWarning});
       }
      }

      if(isMobilePhone()) {
        this.zoomOutFromMobileFlipCard({
          node,
          panToNodeCallback4Mobile,
          callback,
        });
      } else{
        this.panAnimateToNode({node, openFlipPanelForFocus, skipScrollTo: false, hasFirstTreeMatchCountNode, hasFirstRecordMatchCountNode, hasNodeForPublicWarning, showMatchBubble: true, callback});
      }

    }, 500);

  }

  panAnimateToNode({
    node,
    clickedImmediateFamily,
    targetScale,
    showMatchBubble,
    yShift,
    xShift,
    onlyPan,
    callback,
    triggerPedigreeCallout,
    releaseQueueOfFetchedProfilesData,
    callbackFetchResolveAndPopModal,
    openFlipPanelForFocus,
    skipScrollTo,
    allowComponentToUpdateCallback,
    inviteCallback,
    showAddMenuCallback,
    openEditCardCallback,
    hasFirstTreeMatchCountNode,
    hasFirstRecordMatchCountNode,
    hasNodeForPublicWarning,
  } ){


    this.visitedCount++; this.visited['panAnimateToNode'] = this.visitedCount;

    const startXPos = this.getCurStagePos().x;
    const endXPos = this.getNodeStagePos({node, yShift, xShift, fromWhere: 'panAnimateToNodeA'}).x;
    const startYPos = this.getCurStagePos().y;
    const endYPos = this.getNodeStagePos({node, yShift, xShift, fromWhere: 'panAnimateToNodeB'}).y;
    const xDirection = ( startXPos - endXPos < 0 ? 1 : -1);
    const yDirection = ( startYPos - endYPos < 0 ? 1 : -1)
    const xDistance = Math.abs(startXPos - endXPos);
    const yDistance = Math.abs(startYPos - endYPos);
    const steps = numOfStepsOnAnimatedPan;
    const xStepsArray = makeArrayOfHalfValuesStartingWith(xDistance, steps);
    const yStepsArray = makeArrayOfHalfValuesStartingWith(yDistance, steps);

    this.clearAllAnimations({fromWhere: 'panAnimateToNode'});

    this.panAnimateTimeInterval = setInterval(()=>{

      if (!this.stage.current) {
        console.warn('Stage is not available. Clearing interval.');
        clearInterval(this.panAnimateTimeInterval);
        return;
      }

      let stepX = xStepsArray.shift();
      let stepY = yStepsArray.shift();
      this.stage.current.move({
        x: stepX * xDirection,
        y: stepY * yDirection,
      });

      this.stage.current.batchDraw();
      if( xStepsArray.length === 0 ) {
        clearInterval(this.panAnimateTimeInterval);

        const obj = {
          x: this.getNodeStagePos({node, yShift, xShift, fromWhere: 'panAnimateTimeInterval'}).x,
          y: this.getNodeStagePos({node, yShift, xShift, fromWhere: 'panAnimateTimeInterval'}).y
        };

        this.stage.current.position(obj);
        this.stage.current.batchDraw();

        this.calcNewStageCenterNodePos();
        this.redraw({skipScrollTo, clickedImmediateFamily});

        if(onlyPan) {

          if( this.showflipPanelAfterAnimateComplete() ) {
            setTimeout(() => {
              this.toggleFlipPanel({node, from: 'doOnLastScale'});
            }, 10);
          }

          if(typeof(allowComponentToUpdateCallback) !== 'undefined') allowComponentToUpdateCallback()
          if(typeof(callback) !== 'undefined') callback()

          return;
        }

        if(typeof(triggerPedigreeCallout) !== 'undefined') triggerPedigreeCallout()

        setTimeout(() => {
          this.zoomAnimateToNode({
            node,
            clickedImmediateFamily,
            targetScale,
            showMatchBubble,
            yShift,
            xShift,
            callback,
            releaseQueueOfFetchedProfilesData,
            callbackFetchResolveAndPopModal,
            openFlipPanelForFocus,
            skipScrollTo,
            inviteCallback,
            showAddMenuCallback,
            openEditCardCallback,
            hasFirstTreeMatchCountNode,
            hasFirstRecordMatchCountNode,
            hasNodeForPublicWarning,
           } );
        },
        pauseMillisecB4Zoom);

      }
    }, panSpeedInMilisecs);

  }

  openFirstMatchModelAndShiftCanvas({node, hasFirstTreeMatchCountNode, hasFirstRecordMatchCountNode, hasNodeForPublicWarning, yShift, xShift}){


      this.visitedCount++; this.visited['openFirstMatchModelAndShiftCanvas'] = this.visitedCount;

      let stagePosObj = { x: this.getNodeStagePos({node, yShift, xShift, fromWhere: 'drawZoomCanvas'}).x, y: this.getNodeStagePos({node, yShift, xShift, fromWhere: 'drawZoomCanvas'}).y };

      if( typeof(hasFirstTreeMatchCountNode) !== 'undefined' ||
          typeof(hasFirstRecordMatchCountNode) !== 'undefined' ||
          typeof(hasNodeForPublicWarning) !== 'undefined'
        ){

        if(!isMobilePhone() && typeof(hasNodeForPublicWarning) === 'undefined') stagePosObj.x += firstCountNodeShiftX;

        if(isMobilePhone()){

          let removeBubbleHeight =  (this.props.canvasHeight / 2) / this.stage.current.scaleX();
          let shiftDown = (this.props.canvasHeight / this.stage.current.scaleX()/1.1);
          stagePosObj.y += shiftDown;

          if( typeof(hasNodeForPublicWarning) !== 'undefined' && !this.props.isDualPedigree ){
            stagePosObj.y -= removeBubbleHeight;
          }
        }

      }

      this.stage.current.position(stagePosObj);
      this.calcNewStageCenterNodePos();

      if (typeof this.props.firstTreeMatchCountNode !== 'undefined' && this.props.firstTreeMatchCountNode !== null) {
        node = this.props.firstTreeMatchCountNode;
        if (node !== null && node !== undefined) {
          this.setState({
            firstTreeMatchCountNotify: true,
            firstMatchCountNodeSeen: true
          });
          this.showMatchBubbleFor(node.toString());
        } else {
          console.error('Node is null or undefined');
        }

      }

      if(typeof(hasFirstRecordMatchCountNode) !== 'undefined' ){
        node = this.props.firstRecordMatchCountNode;
        if (node !== null && node !== undefined) {
          this.setState({
            firstRecordMatchCountNotify: true,
            firstMatchCountNodeSeen: true
          });
          this.showMatchBubbleFor(node.toString());
        } else {
          console.error('Node is null or undefined');
        }
      }

  }

  zoomAnimateToNode({
    node,
    clickedImmediateFamily,
    targetScale,
    showMatchBubble,
    yShift,
    xShift,
    callback,
    releaseQueueOfFetchedProfilesData,
    callbackFetchResolveAndPopModal,
    openFlipPanelForFocus,
    skipScrollTo,
    inviteCallback,
    showAddMenuCallback,
    openEditCardCallback,
    panToNodeCallback4Mobile,
    zoomOutFromMobileFlipCardCallback,
    callbackAfterGotoHashNode,
    hasFirstTreeMatchCountNode,
    hasFirstRecordMatchCountNode,
    hasNodeForPublicWarning,
   } ){

    this.visitedCount++; this.visited['zoomAnimateToNode'] = this.visitedCount;

    const fromScale = this.stage.current.scaleX();

    let toScale = ( isMobilePhone() ? targetFocusMobileScale: targetFocusDesktopScale);
    toScale = ( typeof(targetScale) !== 'undefined' ? targetScale: toScale);

    let zoomScalesArr = null;
    if(fromScale > toScale){
      zoomScalesArr = buildArrayOfScalesForZooming('out', numberOfZoomSteps, fromScale, toScale);
    } else {
      zoomScalesArr = buildArrayOfScalesForZooming('in', numberOfZoomSteps, fromScale, toScale);
    }

    const lastScaleInArray = zoomScalesArr[zoomScalesArr.length - 1];
    const firstScaleInArray = zoomScalesArr[0];
    const doOnLastScale = ({node, showMatchBubble}) => {

      this.touchStartScale = this.stage.current.scaleX();
      this.redraw({
        clickedImmediateFamily,
        callback,
        releaseQueueOfFetchedProfilesData,
        callbackFetchResolveAndPopModal,
        skipScrollTo,
        inviteCallback,
        showAddMenuCallback,
        openEditCardCallback,
        panToNodeCallback4Mobile,
        zoomOutFromMobileFlipCardCallback,
        callbackAfterGotoHashNode,
      });
      // console.count('>>> zoomAnimate done <<<<');
      this.zoomedFocusCompleteAfterInitialTreeLoad = true;

      if(typeof(hasFirstTreeMatchCountNode) !== 'undefined' ||
         typeof(hasFirstRecordMatchCountNode) !== 'undefined'  ||
         typeof(hasNodeForPublicWarning) !== 'undefined'
      ) this.openFirstMatchModelAndShiftCanvas({node, hasFirstTreeMatchCountNode, hasFirstRecordMatchCountNode, hasNodeForPublicWarning, yShift, xShift});

      if(isMobilePhone()){

        this.enableTouchmove();

      } else{

        if(typeof(openFlipPanelForFocus) !== 'undefined'){
          openFlipPanelForFocus();
        }

        if( this.showflipPanelAfterAnimateComplete() ) {
          setTimeout(() => {
            this.toggleFlipPanel({node, from: 'doOnLastScale'});
          }, 10);
        }
        this.updateVerticalSliderZoom();

      }

    }

    const drawZoomCanvas = (scale) => {

      this.stage.current.scale({
        x: scale,
        y: scale
      });

      let obj ={ x: this.getNodeStagePos({node, yShift, xShift, fromWhere: 'drawZoomCanvas'}).x, y: this.getNodeStagePos({node, yShift, xShift, fromWhere: 'drawZoomCanvas'}).y };

      if( typeof(hasFirstTreeMatchCountNode) !== 'undefined' || typeof(hasFirstRecordMatchCountNode) !== 'undefined'){
        obj.x += firstCountNodeShiftX;
      }

      this.stage.current.position(obj);
      this.calcNewStageCenterNodePos();

    }

    if ( typeof(targetScale) !== 'undefined' && firstScaleInArray === targetScale) {

      doOnLastScale({node, showMatchBubble});

    } else {

      let delayZoom = 0;

      zoomScalesArr.forEach((scale) =>{

        delayZoom += zoomSpeedInMilisecs;


        const zoomInstance = setTimeout(() => {

          drawZoomCanvas(scale);

          if( scale ===  lastScaleInArray) {

            doOnLastScale({node, showMatchBubble});

          }

        }, delayZoom);

        this.zoomQueueArray.push(zoomInstance);

      })

    }

  }
/*

  teleportToNodeForPedigree({ hasFirstTreeMatchCountNode, hasFirstRecordMatchCountNode, hasNodeForPublicWarning, callback }){

    let scaleObj = {
      x: targetFocusDesktopScale,
      y: targetFocusDesktopScale
    }

    this.stage.current.scale(scaleObj);
    const node = ( typeof(hasFirstTreeMatchCountNode) !== 'undefined' ? this.props.firstTreeMatchCountNode: this.props.firstRecordMatchCountNode) ;
    if( !node) return;
    let stagePosObj = { x: this.getNodeStagePos({node, fromWhere: 'teleportToNodeForPedigree'}).x, y: this.getNodeStagePos({node, fromWhere: 'teleportToNodeForPedigree'}).y };


    if( typeof(hasFirstTreeMatchCountNode) !== 'undefined' ||
        typeof(hasFirstRecordMatchCountNode) !== 'undefined' ||
        typeof(hasNodeForPublicWarning) !== 'undefined'
      ){

      if(!isMobilePhone() && typeof(hasNodeForPublicWarning) === 'undefined') stagePosObj.x += firstCountNodeShiftX;

      if(isMobilePhone()){

        let removeBubbleHeight =  (this.props.canvasHeight / 2) / this.stage.current.scaleX();
        let shiftDown = (this.props.canvasHeight / this.stage.current.scaleX()/1.1);
        stagePosObj.y += shiftDown;

        if( typeof(hasNodeForPublicWarning) !== 'undefined' ){
          stagePosObj.y -= removeBubbleHeight;
        }

       console.log(`%c stagePosObj.y : ${ stagePosObj.y }`, [
         'color: white',
         'background: orange',
         'font-size: 14px',
         'border: 5px solid red',
         'padding: 10px',
         ].join(';'));

      }
    }

    this.stage.current.position(stagePosObj);
    this.calcNewStageCenterNodePos();

    setTimeout(() => {

      if( typeof(hasFirstTreeMatchCountNode) !== 'undefined' ){
        const node = this.props.firstTreeMatchCountNode;

        this.setState({
          firstTreeMatchCountNotify: true,
        });
        if(!isMobilePhone()){
          this.showMatchBubbleFor(node.toString());
          // this.refs[`node-tab-${node}`].tabRefClickToLaunchNotifyModal({hasFirstTreeMatchCountNode});
        }
      }


      if( typeof(hasFirstRecordMatchCountNode) !== 'undefined' ){
        const node = this.props.firstRecordMatchCountNode;

        this.setState({
          firstRecordMatchCountNotify: true,
        });
        if(!isMobilePhone()){
          this.showMatchBubbleFor(node.toString());
          // this.refs[`node-tab-${node}`].tabRefClickToLaunchNotifyModal({hasFirstRecordMatchCountNode});
        }
      }


      // if(typeof(hasFirstTreeMatchCountNode) !== 'undefined' ){
      //   node = this.props.firstTreeMatchCountNode;

      //   this.setState({
      //     firstTreeMatchCountNotify: true,
      //     firstMatchCountNodeSeen: true
      //   });
      //   this.showMatchBubbleFor(node.toString());
      // }

      // if(typeof(hasFirstRecordMatchCountNode) !== 'undefined' ){
      //   node = this.props.firstRecordMatchCountNode;

      //   this.setState({
      //     firstRecordMatchCountNotify: true,
      //     firstMatchCountNodeSeen: true
      //   });
      //   this.showMatchBubbleFor(node.toString());
      // }


      if( typeof(callback) !== 'undefined' ) callback();

    }, 1000);
  }
 */


  teleportToPedigreeCenter({ node, hasFirstTreeMatchCountNode, hasFirstRecordMatchCountNode, hasNodeForPublicWarning, callback, fromWhere }){

    this.visitedCount++; this.visited['teleportToPedigreeCenter'] = this.visitedCount;

    let scaleObj = {
      x: targetFocusDesktopScale,
      y: targetFocusDesktopScale
    }

    let positionObj = {
      x: 0,
      y: 10
    }

    if(isMobileTablet()){
      scaleObj = {
        x: targetFocusPedigreeIpadScale,
        y: targetFocusPedigreeIpadScale
      }
      positionObj = {
        x: targetFocusPedigreeIpadCenterX,
        y: targetFocusPedigreeIpadCenterY
      }
    }

    if(isMobilePhone()){
      scaleObj = {
        x: targetFocusMobileScale,
        y: targetFocusMobileScale
      }
      positionObj = {
        x: targetFocusPedigreeMobilePhoneCenterX,
        y: targetFocusPedigreeMobilePhoneCenterY
      }
    }

    if( dualPedigreeMode ){

      let scaleDim = undefined;
      scaleDim = targetDualPedigreeChartScale;

      if(isMobileTablet() ){
        scaleDim = ( isAndroidTablet() ? targetDualPedigreeChartAndroidTabletScale : targetDualPedigreeChartIpadScale);
      }

      scaleObj = {
        x: scaleDim,
        y: scaleDim
      }

      positionObj = {
        x: targetDualPedigreePosX,
        y: targetDualPedigreePosY
      }
    }

    if(minimal){
      scaleObj.x = 2;
      scaleObj.y = 2;
      positionObj.x -= 90;
      positionObj.y -= 190;
    }

    this.stage.current.scale(scaleObj);
    this.stage.current.position(positionObj);
    this.stage.current.batchDraw();
    this.updateVerticalSliderZoom();
    this.calcNewStageCenterNodePos();

    if( dualPedigreeMode ){

      this.stageClickCanCloseFlipPanel = false;
      this.setBackgroundTextureDualPedigree();

    } else {

      if(typeof(node) !== 'undefined'){

        if( typeof(hasFirstTreeMatchCountNode) !== 'undefined' ||
            typeof(hasFirstRecordMatchCountNode) !== 'undefined' ||
            typeof(hasNodeForPublicWarning) !== 'undefined'
          ){

          this.openFirstMatchModelAndShiftCanvas({node, hasFirstTreeMatchCountNode, hasFirstRecordMatchCountNode, hasNodeForPublicWarning});

          this.showMatchBubbleFor(node.toString());

        }

      }

    }

  }

  testStagePos({x,y}){

    this.stage.current.position({x,y});
  }

  panAnimateCenterPedigree({shiftX, callback}){

    document.getElementById("debugDiv").innerHTML += '...panAnimateCenterPedigree<br/>';

    alert('Bomb');

    return;

  }

  zoomAnimateCenterPedigree(){

    this.visitedCount++; this.visited['zoomAnimateCenterPedigree'] = this.visitedCount;

    const fromScale = this.stage.current.scaleX();

    let toScale = ( isMobilePhone() ? targetFocusMobileScale: targetFocusDesktopScale);
    toScale = ( isMobileTablet() ? targetFocusPedigreeIpadScale : toScale);

    if(minimal){
      toScale = 2;
    }

    let zoomScalesArr = null;
    if(fromScale > toScale){
      zoomScalesArr = buildArrayOfScalesForZooming('out', numberOfZoomSteps, fromScale, toScale);
    } else {
      zoomScalesArr = buildArrayOfScalesForZooming('in', numberOfZoomSteps, fromScale, toScale);
    }

    const lastScaleInArray = zoomScalesArr[zoomScalesArr.length - 1];
    const doOnLastScale = () => {

      this.touchStartScale = this.stage.current.scaleX();
      this.redraw({});
      this.zoomedFocusCompleteAfterInitialTreeLoad = true;
      if(isMobilePhone()){

        this.enableTouchmove();

      } else{

        this.updateVerticalSliderZoom();

      }

    }

    const drawZoomCanvas = (scale) => {


      /*

          POSITION

       */

      let posObj = {
        x: ( isMobileTablet() ? targetFocusPedigreeIpadCenterX: 0),
        y: ( isMobileTablet() ? targetFocusPedigreeIpadCenterY: 10)
      }

      if(minimal){
        posObj.x -= 90;
        posObj.y -= 190;
      }

      if( dualPedigreeMode ){
        posObj = {
          x: targetDualPedigreePosX,
          y: targetDualPedigreePosY
        }
      }

      this.stage.current.position(posObj);

      /*

          SCALE

       */

      let scaleObj = {
        x: scale,
        y: scale
      }

      if( dualPedigreeMode ){
        scaleObj = {
          x: targetDualPedigreeChartScale,
          y: targetDualPedigreeChartScale
        }
      }

      this.stage.current.scale(scaleObj);

      this.stage.current.batchDraw();
      this.calcNewStageCenterNodePos();
    }

    let delayZoom = 0;

    zoomScalesArr.forEach((scale) =>{

      delayZoom += zoomSpeedInMilisecs;

      const zoomInstance = setTimeout(() => {

        drawZoomCanvas(scale);

        if( scale ===  lastScaleInArray) {

          doOnLastScale();

        }

      }, delayZoom);

      this.zoomQueueArray.push(zoomInstance);

    })

  }


  zoomTo({scale, doSetStateSliderValue}){ // Does not involve node

    if(this.touchMoveDisabled ) {
      return;
    }

    this.stage.current.scale({ x: scale, y: scale});

    this.stage.current.position({
      x: this.getCurStagePos().x,
      y: this.getCurStagePos().y
    });

    this.stage.current.batchDraw();
    const sliderValue = scale * 10;
    if( typeof(doSetStateSliderValue) !== 'undefined' &&
        doSetStateSliderValue
    ){
      // console.log('setstate');

      this.setState({sliderValue});
    }

  }

  gotoMainStagePos({x, y}){

    this.visitedCount++; this.visited['gotoMainStagePos'] = this.visitedCount;

    this.stage.current.position({x, y});
    this.calcNewStageCenterNodePos();
    this.setViewPortHook();
    this.redraw({skipAdjustDragContainerPosition: true});
  }

  productTourForNodePoint({node, tipPointedDirection, nudgeX, nudgeY}){

    if(typeof(node) === 'undefined' ) return;

    let xShift = 0;
    let yShift = 0;
    if( tipPointedDirection === 'left') xShift = -280;
    if( tipPointedDirection === 'right') xShift = 300;
    if( tipPointedDirection === 'up') yShift = -240;
    if( tipPointedDirection === 'down') yShift = -60;

    xShift += nudgeX;
    yShift += nudgeY;

    this.panAnimateToNode({
        node,
        yShift,
        xShift
      }
    );

  }

  unshiftProductTourWhenFlipPanelOpenning(){

    const triangleProductTourTip = document.getElementById('triangleProductTourTip');
    let triangleProductTourTipLeft = parseInt(triangleProductTourTip.style.left, 10);
    triangleProductTourTipLeft -= flipPanelWidth / 2;
    triangleProductTourTip.style.left = `${triangleProductTourTipLeft}px`;

    const modalProfileContent = document.getElementById('modalProfileContent');
    let modalProfileContentLeft = parseInt(modalProfileContent.style.left, 10);
    modalProfileContentLeft -= flipPanelWidth / 2;
    modalProfileContent.style.left = `${modalProfileContentLeft}px`;

  }

  teleportToNode(node, callback){

    this.visitedCount++; this.visited['teleportToNode'] = this.visitedCount;

    if(typeof(node) === 'undefined' ) return;

    this.showProgressIndicator();
    this.stage.current.position({ x: this.getNodeStagePos({node, fromWhere: 'teleportToNode'}).x, y: this.getNodeStagePos({node, fromWhere: 'teleportToNode'}).y });
    this.stage.current.batchDraw();

    this.stageCenteredNodePosX = this.nodeObjs[node].left;
    this.stageCenteredNodePosY = this.nodeObjs[node].top;

    /*
      If teleporting to node far from focus, need small period to update viewport before
      redraw knows which profiles to fetchmore
     */

    setTimeout(() => {
      this.resetStagePos();
      this.unsetRedrawCanvasTree()
    }, 600);

    if(typeof(callback) !== 'undefined'){
      callback();
    };

  }

  skipZoomInOutSteppingNow(){
    this.skipZoomInOutStepping = true;
  }

  zoomInOutStepping({zoomOutAlltheWay, target}){
    if(minimal) return;
    if(this.skipZoomInOutStepping ) return;
    this.allowComponentUpdate(false);
    const numberOfZoomSteps = 10;
    const fromScale = this.stage.current.scaleX();
    let toScale = ( fromScale === exitMobileFlipCardScale || typeof(zoomOutAlltheWay) !== 'undefined' ?
          zoomedAlltheWayOutForMobileScale : exitMobileFlipCardScale);
    if(typeof(target) !== 'undefined'){ toScale = target;}
    let zoomScalesArr = buildArrayOfScalesForZooming('out', numberOfZoomSteps, fromScale, toScale);

    clearInterval(this.zoomOutTimeInterval);
    this.zoomOutTimeInterval = setInterval(()=>{
      // console.log(JSON.stringify(zoomScalesArr, null, 2));
      let scale = zoomScalesArr.shift();
      if(zoomScalesArr.length === 0 ) {
        clearInterval(this.zoomOutTimeInterval);
        this.allowComponentUpdate(true);
        if(!isMobilePhone()){

          const sliderValue = this.stage.current.scaleX() * 10;

          this.setState({sliderValue})
          this.redraw({});
        }
      }
      if(typeof(scale) !== 'undefined') this.zoomTo({scale, doSetStateSliderValue: false});
    }, 20);
  }

  stopStageClickPropagation({fromWhere}){
    const delayProp = 200;
    this.stageCanBeClickedTouchedHovered = false;
    clearTimeout(this.stageCanBeClickedTouchedHoveredTimeOut);
    this.stageCanBeClickedTouchedHoveredTimeOut =
      setTimeout(() => {
        this.stageCanBeClickedTouchedHovered = true;
      }, delayProp);
  }

  disableStageDragging(){
    this.stage.current.draggable(false);
  }

  enableStageDragging(){

    // this.stage.current.draggable(true);

    const fromWhere = 'enableStageDragging';
    const logExceptionAndRun = debugStageCurrent(function(stageCurrent) { // exceptions tweak

      stageCurrent.draggable(true);

    }, fromWhere).bind(this);

    logExceptionAndRun();

    this.enabledStageDraggingCount++;

  }

  showMatchBubbleFor(node){

    this.visitedCount++; this.visited['showMatchBubbleFor'] = this.visitedCount;

    if(dualPedigreeMode) return;
    node = node.toString();
    this.skipZoomInOutStepping = true;
    if(!this.matchBubbleAppears) {
      if( typeof(window.forceHideMoreList) === 'function'  ) window.forceHideMoreList();
      this.matchBubbleAppears = true;

      this.setState({ nodeShownInMatchBubble: node });
      this.stopStageClickPropagation({fromWhere: 'showMatchBubbleFor A'})
    } else{
      this.hideMatchBubble();
      this.matchBubbleAppears = true;

      this.setState({ nodeShownInMatchBubble: node });
      this.stopStageClickPropagation({fromWhere: 'showMatchBubbleFor B'})
    }

  }

  hideMatchBubble(){
    if(this.matchBubbleAppears && !this.state.productTourVisible && !this.state.firstRecordMatchCountNotify && !this.state.firstTreeMatchCountNotify) {
      this.matchBubbleAppears = false;

      this.setState({ nodeShownInMatchBubble: null });
    }
  }

  shownToolTip: false
  showToolTipFor({
    node,
    placement,
    shiftLeftOnToolTip,
    shiftTopOnToolTip,
    bubbleWidth,
    content,
    runTranslatePhraseInToolTip,
    translateVarStrInToolTip,
    okLabelInToolTip,
    toolTipDelay,
    confirmLabelInToolTip,
    okLabelWidthInToolTip,
    confirmLabelWidthInToolTip,
    okCallbackInToolTip,
    confirmCallbackInToolTip,
  }){

    if( typeof(window.forceHideMoreList) !== 'undefined' ) window.forceHideMoreList();

    if(typeof(toolTipDelay) === 'undefined') toolTipDelay = 800;

    this.showToolTipTimeout = null;
    clearTimeout(this.showToolTipTimeout);
    this.showToolTipTimeout = setTimeout(() => {
      if(!this.shownToolTip){
        this.shownToolTip = true;


        this.setState({
          nodeShownInToolTip: node,
          placementShownInToolTip: placement,
          shiftLeftOnToolTip,
          bubbleWidth,
          shiftTopOnToolTip,
          runTranslatePhraseInToolTip,
          translateVarStrInToolTip,
          contentShownInToolTip: content,
          fromWhere: 'showToolTipFor',
          okLabelInToolTip,
          confirmLabelInToolTip,
          okLabelWidthInToolTip,
          confirmLabelWidthInToolTip,
          okCallbackInToolTip,
          confirmCallbackInToolTip,
        });
      }
    }, toolTipDelay);
    setTimeout(() => {
      this.shownToolTip = false;
    }, 3000);

  }

  hideToolTip(){
    clearTimeout(this.showToolTipTimeout);
    // console.log(' hideToolTip ');
    this.setState({
      nodeShownInToolTip: null,
      bubbleWidth: undefined,
      shiftLeftOnToolTip: undefined,
      shiftTopOnToolTip: undefined,
      contentShownInToolTip: '',
      toolTipDelay: undefined,
      okLabelInToolTip: undefined,
      confirmLabelInToolTip: undefined,
      okLabelWidthInToolTip: undefined,
      confirmLabelWidthInToolTip: undefined,
      okCallbackInToolTip: undefined,
      confirmCallbackInToolTip: undefined,
    });
    this.shownToolTip = true;
    setTimeout(() => {
      this.shownToolTip = false;
    }, 800);
    setTimeout(() => {
      this.skipZoomInOutStepping = false;
    }, 1100);
  }

  resetCanvasDimensions(){

    this.visitedCount++; this.visited['resetCanvasDimensions'] = this.visitedCount;

    const canvasWidth = window.innerWidth - (canvasSideMargin * 2);
    if(typeof(this.props.setCanvasWidth) !== 'undefined') {
      this.props.setCanvasWidth({width: canvasWidth})
    }

    if(isDevelopment) return;
    doWhenReady({
      argument: {},
      condition: ()=>{
        return typeof(window.calcHeight) === 'function'
      },
      callback: () =>{
        window.calcHeight();
      },
      attempts: {ongoing:0, end: 9999999},
      fromWhere: 'resetCanvasDimensions',
    })
  }

  resetCanvas(){

    this.visitedCount++; this.visited['resetCanvas'] = this.visitedCount;

    clearTimeout(this.resizeWindowTimeOut);
    this.resizeWindowTimeOut = setTimeout(() => {

      console.log('resetCanvas');

      this.setState({
        warnPublic: false,
        firstTreeMatchCountNotify: false,
        firstRecordMatchCountNotify: false,
      })
      this.resetCanvasDimensions();
      this.redraw({});
    }, 500);
  }

  bindWindowEvents(){

    addEvent(window, "popstate", (event) => {

      this.visitedCount++; this.visited['popstateEvent'] = this.visitedCount;
      this.afterClickedOnBackOrFowardButton();

    });

    addEvent(window, "resize", (event) => {
      this.visitedCount++; this.visited['resizeWindow'] = this.visitedCount;
      this.resetCanvas();
    });
  }

  bindRefs(){
    this._notificationSystem = this.refs.notificationSystem;
  }

  setDidRequestLoadTreeToTrue(where){
    this.didRequestReLoadTree = true;
  }

  showNavigationalControls(){

    this.setState({
      showNavigationalControls: true
    })
  }

  showProgressIndicator(){

    if(!isDevelopment && !this.props.isDualPedigree){

      window.Geni.showPageSpinner();}
    else {
      this.setState({
        showProgressIndicator: true,
      })
    }

  }

  hideProgressIndicator(){

    if(!isDevelopment && !this.props.isDualPedigree) window.Geni.hidePageSpinner();
    this.setState({
      showProgressIndicator: false,
    })

  }

  refreshGotoList(){

    this.setState({
      refreshGotoList: true,
    })
    setTimeout(() => {

      this.setState({
        refreshGotoList: false,
      })
    }, 2000);
  }

  resetFetchedAllProfiles(){
    this.requestFetchForAllProfiles = false;

    this.setState({
      allProfilesFetched: false,
    })
  }

  setShowConfirmMobile({bool, content, onMobileConfirm, onMobileOk, mobileOkLabel, mobileConfirmLabel}){
    this.setState({
      showConfirmMobile: bool,
      mobileConfirmContent: content,
      mobileOkLabel,
      mobileConfirmLabel,
      onMobileConfirm,
      onMobileOk,
    })
  }

  showTreeOverlay(){
    if( this.state.moveOperationWithCtrlKeyDnActivated ) return;

    this.setState({
      showTreeOverlay: true
    })
  }

  hideTreeOverlay(){

    this.setState({
      showTreeOverlay: false
    })
  }

  setPushToHistory(){

    this.setState({
      pushToHistory: true
    })
  }

  unsetPushToHistory(){

    this.setState({
      pushToHistory: false
    })
  }

  setNextNodeForPruning(node){

    this.setState({
      nextNodeForPruning: node
    })
  }

  unsetNextNodeForPruning(){

    this.setState({
      nextNodeForPruning: null,
    })
  }

  setStageClickCanZoomStep(node){
    this.stageClickCanZoomStep = true;
  }

  unSetStageClickCanZoomStep(){
    this.stageClickCanZoomStep = false;
  }

  isContinueFromReloadwithNewTree(){
    return  this.didRequestReLoadTree &&
            typeof(this.nodeObjs) !== 'undefined' &&
            typeof(this.props.focusNode) !== 'undefined' &&
            this.props.treeLoaded;
  }

  hideNotificationModal({ launchProductTour }){

    setTimeout(() => {

      let setObj = {
        warnPublic: false,
        firstTreeMatchCountNotify: false,
        firstRecordMatchCountNotify: false,
        prIdForWarning: undefined,
        showProgressIndicator: false,
      };

      this.setState(setObj);
    }, 800);

    if( this.state.lastStepNotifySeen ) return;

    const callbackAfterPreferenceFetch = ({ show_guide }) => {
      if(!show_guide ) return;
      setTimeout(() => {
        if(!this.state.lastStepNotifySeen) this.showProductTourAfterStateHasTree({ fromWhere: '9u8457305'});
      }, 1000);
    }

    if( typeof(launchProductTour) !== 'undefined' && launchProductTour) this.props.fetchPreferences({callbackAfterPreferenceFetch});

  }

  showProductTourAfterStateHasTree({ autoStepping, fromWhere }){

    if( this.isProductTourWithFirstMaleGhostAndStartStepAtOne && !this.productTourStepLaunchAfterFetch ){
      this.teleportToNode(this.props.firstMaleGhostNode)
    } else {
      this.setState({
        productTourVisible: this.props.preferences.get('show_guide'),
        lastStepNotifySeen: !this.props.preferences.get('show_guide'),
        autoStepping,
      })
    }

  }

  showProductTourForFirstMaleGhostAndStartStepAtOne({ fromWhere }){
    setTimeout(() => {
      this.setState({
        productTourVisible: this.props.preferences.get('show_guide'),
        profilesAllFetchedForFirstGhostNodeNeighbors: true,
        lastStepNotifySeen: !this.props.preferences.get('show_guide')
      })
    }, 1000);
  }

  hidingProductTour = false;
  hideProductTour({ fromWhere, withLastStepNotify, skipGotoFocus, lastStepNotifySeen }){

    if(!this.state.productTourVisible) return;

    const callback = () => {
      setTimeout(() => {


        this.setState({
          productTourVisible: false,
          lastStepNotifySeen:  true,
        })

        this.hidingProductTour = false;
        this.togglingProductTour = false;

      }, 400);
    }

    const canRunShowLastStepNotify = () => {
      return typeof(withLastStepNotify) !== 'undefined' && withLastStepNotify && this.state.productTourVisible && typeof(window.showLastStepNotify) !== 'undefined' ;
    }

    if( canRunShowLastStepNotify() && !this.state.lastStepNotifySeen){

      if(!this.hidingProductTour){
        this.hidingProductTour = true;
        this.togglingProductTour = true;
        window.saveProductTourPreferences({});
        window.showLastStepNotify({ skipGotoFocus, callback });
      }

    } else {

      let obj = {
        productTourVisible: false,
      }

      if( typeof(lastStepNotifySeen) !== 'undefined' ) {
        obj = {...obj, lastStepNotifySeen}
      }


      this.setState(obj);


      /*
       *
       *
       *
       *
        Launch firstMatch Notification modal when user dismissed product tour
       *
       *
       *
       */

      const callback = () => {
        setTimeout(() => {

          this.setState({
            firstMatchCountNodeSeen: true // forceUpdate Hack to allow time for translation to finish loading then determine height of callout
          });
        }, 800);

      }

      if( !this.state.firstMatchCountNodeSeen ){

        if( typeof(this.props.firstTreeMatchCountNode) !== 'undefined'  ){
          this.gotoFocusNode({node: this.props.firstTreeMatchCountNode, hasFirstTreeMatchCountNode: true, callback});
        }

        if( typeof(this.props.firstRecordMatchCountNode) !== 'undefined'  ){
          this.gotoFocusNode({node: this.props.firstRecordMatchCountNode, hasFirstRecordMatchCountNode: true, callback});
        }

      }


    }

  }

  togglingProductTour = false;
  toggleProductTour({ fromWhere }){
    console.log(`lastStepNotifySeen: `, this.state.lastStepNotifySeen);
    if(!this.togglingProductTour){
      this.togglingProductTour = true;

      this.setState({
        productTourVisible: this.state.productTourVisible ? false: true,
        lastStepNotifySeen: true,
      })
      setTimeout(() => {
        this.togglingProductTour = false;
      }, 1000);
    }
  }

  setDocumentTitle(nodeObj){
    const {fn, ln, prId} = nodeObj;
    let title = `Geni Tree - ` + fn + ' ' + (typeof(ln) !== 'undefined' ? ln: '');
    if ( isDevelopment ) title = `Development - ` + fn + ' ' + (typeof(ln) !== 'undefined' ? ln: '') + ' - '  + prId + ' - '  + ( dualPedigreeMode   ? ' dualPedigreeMode ': '');
    if ( isSeinfeld ) title = `Seinfeld - ` + fn + ' ' + (typeof(ln) !== 'undefined' ? ln: '') + ' - '  + prId + ' - '  + ( dualPedigreeMode   ? ' dualPedigreeMode ': '');
    window.document.title = title;
  }

  destroyAtomNotification({all, which, fromWhere}){


    this.debugOrder++;
    this.debugObj['destroyAtomNotification'] = {order: this.debugOrder, 'part': 'A'}

    if(typeof(this.notifyNow) !== 'undefined'){

      // if(typeof(all) !== 'undefined' && all){
        this.notifyNow.destroy();

        this.debugOrder++;
        this.debugObj['destroyAtomNotification'] = {order: this.debugOrder, 'part': 'B'}

      // }

      // if(typeof(which) !== 'undefined' && typeof(this.notifyNow.close) !== 'undefined' ){
      //   this.notifyNow.close(which);
      // }

    }
  }

  notifyWithAtom({which, message, description, type, duration, onOpen, onClose, okLabel = 'Ok', confirmLabel, confirmCallback}){

      this.debugOrder++;
      this.debugObj['notifyWithAtom'] = {order: this.debugOrder};

      // this.showDebugLog('notifyWithAtom');


    /*

      which can be:

      InviteMsg
      moveIsActive
      redirectMsg
      externalCall
      confirmDropOnGhost

     */

    this.notifyNow = notification;

    let btn = (
      <div>
        <Button type="primary" size="small" onClick={() => confirmCallback()}>
          {`${confirmLabel}`}
        </Button>&nbsp;&nbsp;
        <Button type="default" size="small" onClick={() => {
          onClose();
          this.notifyNow.destroy();
        }}>
          {`${okLabel}`}
        </Button>
      </div>
    );

    if( isRtl ){
      btn = (
          <div>
            <Button type="default" size="small" onClick={() => {
              this.notifyNow.destroy();
              onClose();
            }}>
              {`${okLabel}`}
            </Button>&nbsp;&nbsp;
            <Button type="primary" size="small" onClick={() => confirmCallback()}>
              {`${confirmLabel}`}
            </Button>
          </div>
          );
    }

    if(typeof(onOpen) !== 'undefined') onOpen();

    const obj = {
      key: which,
      message,
      description,
      type,
      placement: 'bottomRight',
      duration: ( typeof(duration) === 'undefined' ? 3 : duration),
      onOpen: ()=>{
        console.log('notify open');
      },
      onClose,
    }

    if(typeof(confirmLabel) !== 'undefined') obj['btn'] = btn;

    this.notifyNow[type](obj);

  }

  reloadFocusAndGotoHighlight( { prIdToTeleport } ){
    const prIdToRedraw = this.props.focusPrId;
    const cacheBreakPics = true;
    this.reloadCanvasTree(prIdToRedraw, { prIdToTeleport, cacheBreakPics });
  }

  resetReloadCanvasTree(){
    this.setState({reloadCanvasTree: false});
  }

/*

  reloadFanChart( prIdToRedraw, param ){

    this.visitedCount++; this.visited['reloadFanChart'] = this

    let obj = {
      reloadCanvasTree: true,
      treeIsVisable: false,
      allProfilesFetched: false,
      gotoComponentEnabled: false,
      navigationPanelIsUp: false,
      mapNavTabActive: false,
      gotoNavTabActive: false,
      pedigreeAddboxVisible: false,
      warnPublic: false,
      firstTreeMatchCountNotify: false,
      firstRecordMatchCountNotify: false,
      warningPublicRequested: false,
      prIdForWarning: undefined,
      prIdToTeleport: undefined,
      prIdToRedraw,
    }


    if(!dualPedigreeMode){
      this.toggleFlipPanel({close: true, from: 'reloadCanvasTree'});
      if(!isDevelopment) window.Geni.showPageSpinner();
    } else {
      obj = {...obj,
        showProgressIndicator: true,
      }
    }

    if( typeof(param) !== 'undefined' &&  typeof(param.prIdToTeleport) !== 'undefined'){

      obj = {...obj, ...{
        cacheBreakPics: (typeof(param.cacheBreakPics) !== 'undefined' ? true: false),
        prIdToTeleport: param.prIdToTeleport,
        prIdForWarning: param.prIdToTeleport,
        warningPublicRequested: typeof(param.warnPublic) !== 'undefined' && param.warnPublic,
      }}

    }

    if( typeof(param) !== 'undefined' &&  typeof(param.unionId) !== 'undefined'){

      obj = {...obj, ...{
        unionIdDualPedigreeChoice: param.unionId,
      }}

    }

    this.setState(obj);

  }
 */

  reloadCanvasTree( prIdToRedraw, param ){

    if( this.props.chartType === 'fan'){
      this.refocusFanChart({prId: prIdToRedraw});
      return;
    }

    this.visitedCount++; this.visited['reloadCanvasTree'] = this.visitedCount;

    this.dualPedigreeBackgroundUserPrefenrenceIsReady = false;
    this.dualPedigree_Render_HiRes_PrIdImgs = [];
    this.dualPedigree_Preview_LowRes_PrIdImgs = [];

console.log(`prIdToRedraw: `, prIdToRedraw);
console.log(`param: `, JSON.stringify(param, null, 2));

    /*

      Test:

        New profiles, same tree:

          Dev:
            callReloadCanvasTree('52003', {prIdToTeleport:'52476', warnPublic:true})
            callReloadCanvasTree('52003', {prIdToTeleport:'52476'})

          Stage:
            callReloadCanvasTree('324002769390004386', {prIdToTeleport:'324003541490004455', warnPublic:true})
            callReloadCanvasTree('324002769390004386', {prIdToTeleport:'324003541490004455'})

        New profile outside original tree:

          Dev:
            callReloadCanvasTree('52003', {prIdToTeleport:'52314', warnPublic:true})
            callReloadCanvasTree('52003', {prIdToTeleport:'52314'})

          Stage:
            callReloadCanvasTree('324002769390004386', {prIdToTeleport:'6000000105486432824', warnPublic:true})
            callReloadCanvasTree('324002769390004386', {prIdToTeleport:'6000000105486432824'})


     */

    let obj = {
      treeIsVisable: false,
      allProfilesFetched: false,
      gotoComponentEnabled: false,
      navigationPanelIsUp: false,
      mapNavTabActive: false,
      gotoNavTabActive: false,
      pedigreeAddboxVisible: false,
      reloadCanvasTree: true,
      warnPublic: false,
      firstTreeMatchCountNotify: false,
      firstRecordMatchCountNotify: false,
      warningPublicRequested: false,
      prIdForWarning: undefined,
      prIdToTeleport: undefined,
      prIdToRedraw,
    }


    if(!dualPedigreeMode){
      this.toggleFlipPanel({close: true, from: 'reloadCanvasTree'});
      if(!isDevelopment) window.Geni.showPageSpinner();
    } else {
      obj = {...obj,
        showProgressIndicator: true,
      }
    }

    if( typeof(param) !== 'undefined' &&  typeof(param.prIdToTeleport) !== 'undefined'){

      obj = {...obj, ...{
        cacheBreakPics: (typeof(param.cacheBreakPics) !== 'undefined' ? true: false),
        prIdToTeleport: param.prIdToTeleport,
        prIdForWarning: param.prIdToTeleport,
        warningPublicRequested: typeof(param.warnPublic) !== 'undefined' && param.warnPublic,
      }}

    }

    if( typeof(param) !== 'undefined' &&  typeof(param.unionId) !== 'undefined'){

      obj = {...obj, ...{
        unionIdDualPedigreeChoice: param.unionId,
      }}

    }

    this.setState(obj);

  }

  triggerPedigreeWarningFromPedTabComponent( { prIdToTeleport } ){

    let node = undefined;
    const checkWhenRefIsAvailableAndNodeInTree = () => {
      node = getNodeFromNodeObjsWithPrId({nodeObjs: this.nodeObjs, prId: prIdToTeleport});
      const nodeIsInTree = () => {
        return ( node !== '-1' && typeof(node) !== 'undefined' );
      }
      return nodeIsInTree() && typeof(this.refs[`node-tab-${node}`]) !== 'undefined'
    }

    const triggerWarningFromPedTabComponent = (node) => {
     node = getNodeFromNodeObjsWithPrId({nodeObjs: this.nodeObjs, prId: prIdToTeleport});
     // this.refs[`node-tab-${node}`].tabRefClickToLaunchNotifyModal({warnPublic: true});
    }

    doWhenReady({
      argument: undefined,
      condition: checkWhenRefIsAvailableAndNodeInTree,
      callback: triggerWarningFromPedTabComponent,
      attempts: {ongoing:0, end: 99999999},
      fromWhere: 'triggerPedigreeWarningFromPedTabComponent'
    })

  }

  launchNotifyModalForPedigreeFromTabComponent({ left, top, hasFirstTreeMatchCountNode, hasFirstRecordMatchCountNode, warnPublic }){
    if( typeof(hasFirstTreeMatchCountNode) !== 'undefined' || typeof(hasFirstRecordMatchCountNode) !== 'undefined' ){
      // console.log(`this.stage.current.scaleX(): `, this.stage.current.scaleX());
      left += (firstCountNodeShiftX / this.stage.current.scaleX());
    }

    // console.log('2 launchNotifyModalForPedigreeFromTabComponent: ', left);
    // document.getElementById("debugDiv2").innerHTML += `left 2: ${left} this.stage.current.scaleX(): ${this.stage.current.scaleX()}`;

    const obj = {
      nodeObjPosForInformModal: { left, top },
      warnPublic,
      hasFirstTreeMatchCountNode,
      hasFirstRecordMatchCountNode,
    };


    this.setState(obj);

  }

  setCacheBreakPicsTrue(){

    this.setState({cacheBreakPics: true});
  }

  setCacheBreakPicsFalse(){

    this.setState({cacheBreakPics: false});
  }

  unsetRedrawCanvasTree(){

    this.setState({
      reloadCanvasTree: false,
      prIdToRedraw: undefined,
      prIdToTeleport: undefined,
      warningPublicRequested: undefined,
      warnPublic: undefined,
    });
  }

  resetFocusNode(){
    // this.props.focusNode = undefined;
  }

  triggerPedigreeCalloutForNode({node}){

    this.hideNotificationModal({});

    if( this.nodeHasNearbyTreeMatches({node}) ){

      this.showHookMessageForNearbyTreeMatches({node});

    } else {

      this.pedigreeAddTabObj[node].triggerClick();

    }

  }

  triggerFloaterMoveDecisionPanel(){

    // this.hideNotificationModal({});
    return this.fanChartComponent.current.launchFloaterMoveDecisionPanel();

  }

  triggerFanChartCalloutForNode({node}){

      this.hideNotificationModal({});
      this.fanChartComponent.current.launchImmediateFamilyPanel();

  }

  nodeHasNearbyTreeMatches = ({node}) => {
      return typeof(this.props.nodeObjs[node].ntm) !== 'undefined' && this.nodeObjs[node].ntm === 1;
  }

  canAddProfile(node){
    return typeof(this.props.nodeObjs[node].a) !== 'undefined' && this.props.nodeObjs[node].a === 1;
  }

  onclickedAddNodeTab(node){

    if( !this.canAddProfile(node) ) return;

    this.hideNotificationModal({});
    this.hideProductTour({fromWhere: 'Y', withLastStepNotify: true, skipGotoFocus: true});
    const targetScale = 5;
    const pr_id = this.props.nodeObjs[node].pr_id;

    const showAddMenuCallback = () => {
      if(typeof(window.showAddMenu) === 'undefined'){
        alert('You are on Development.');return;
      };

      let left = ( !this.state.flipPanelOpened ? 78 : -106);
      left -= 90;
      this.curNodeBeforeClick = node;
      window.showAddMenu(parseInt((window.innerWidth /2) - left, 10), parseInt((window.innerHeight/2) - 5, 10), pr_id)

    }
    this.delayStageClickCanZoomStep();
    this.curZoomScaleBeforeClick = this.stage.current.scaleX();
    if(this.props.isPedigree){
      if(typeof(this.nodeObjs[node].idp) !== 'undefined'){

        this.triggerPedigreeCalloutForNode({node});

      } else {
        this.setPedigreeAddbox({visible: false});
        this.setPushToHistory();
        this.reloadWithNewTree({prId: pr_id, node, triggerPedigreeAddNodeTab: true, fromWhere: 'onclickedAddNodeTab'});
      }

    }

    else if(this.props.isFanChart){

      this.triggerFanChartCalloutForNode({node});
          // showAddMenuCallback();
    }


    else {
      node = node.toString();
      if(node.includes('flip')){
        this.setPushToHistory();
        this.reloadWithNewTree({
          prId: pr_id,
          node,
          triggerDefaultTreeAddNodeTab: true,
          fromWhere: 'onclickedAddNodeTab',
        });
      } else {


        if( this.nodeHasNearbyTreeMatches({node}) ){

          this.showHookMessageForNearbyTreeMatches({node});

        } else {
          let xShift = 115;
          let yShift = -20;
          this.panAnimateToNode({node, targetScale, showAddMenuCallback, xShift, yShift});
        }
      }
    }
  }

  showHookMessageForNearbyTreeMatches({node}){
    this.stopStageClickPropagation({fromWhere: 'showHookMessageForNearbyTreeMatches'});

    let content = 'In order to reduce duplication, nearby tree matches must be resolved before adding to this profile.';

    if( typeof(window.trl) !== 'undefined' ) content = window.trl(content, 'add profile action')

    const that = this;

    this.callHookForMessageAlert({
      type: 'info',
      content,
      title: translatedLabels['Resolve Tree Matches'].translatedLabel,
      duration: 5000,
      confirmLabel: translatedLabels['Resolve'].translatedLabel,
      confirmCallback: function(){
        const href = '/tree/resolve_matches/' + that.nodeObjs[node].prId;
        // window.open(href, '_blank');
        window.location = href;
      },
      okLabel: translatedLabels['Cancel'].translatedLabel,
      okCallback: ()=>{

      }
    });

  }

  showHookMessageNeedForReload(prId){

    this.stopStageClickPropagation({fromWhere: 'showHookMessageForNearbyTreeMatches'});

    let content = 'New profiles have been added.  Click reload to redraw tree.';

    if( typeof(window.trl) !== 'undefined' ) content = window.trl(content, 'add profile action');

    const that = this;

    this.callHookForMessageAlert({
      type: 'info',
      content,
      title: typeof(window.trl) !== 'undefined' ?  window.trl('Reload tree.', 'add profile action'): 'Reload tree.',
      duration: 5000,
      confirmLabel: typeof(window.trl) !== 'undefined' ?  window.trl('Reload', 'add profile action'): 'Reload',
      confirmCallback: function(){
        if(typeof(that.notifyNow) !== 'undefined' ) that.notifyNow.destroy();
        window.reloadTree({focus_pr_id: prId})
      },
      okLabel: translatedLabels['Cancel'].translatedLabel,
      okCallback: ()=>{

      }
    });

  }

  onClickEdit(node, prId){
    this.hideNotificationModal({});
    this.showProgressIndicator();
    this.hideProductTour({fromWhere: 'X', withLastStepNotify: true});
    // const targetScale = 5;
    const openEditCardCallback = () => {
      const pr_id = ( typeof(prId) !== 'undefined' ? prId: this.nodeObjs[node].pr_id);
      if(typeof(window.openEditCard) === 'undefined'){
        console.log('pr_id: ', pr_id);
        alert('You are on Development.');return;
      };
      this.curNodeBeforeClick = node;
      this.showTreeOverlay();
      window.openEditCard(pr_id);
    }

    this.curZoomScaleBeforeClick = this.stage.current.scaleX();
    this.stopStageClickPropagation({fromWhere: 'onclickedEdit'});
    this.delayStageClickCanZoomStep();
    if(this.isPedigreeDev || this.props.isPedigree){
      openEditCardCallback();
    } else {
      openEditCardCallback();
      // this.panAnimateToNode({node, targetScale, openEditCardCallback});
    }

  }

  isNoViewProfile(node){
    return typeof(this.props.nodeObjs[node]) !== 'undefined' &&
    typeof(this.props.nodeObjs[node].nvp) !== 'undefined';
  }

  setKeyPressEnabled( how ){
    this.keyPressEnabled = how;
  }

  resetStagePos(){

    this.visitedCount++; this.visited['resetStagePos'] = this.visitedCount;

    const zoomScale = (this.curZoomScaleBeforeClick !== 0 ? this.curZoomScaleBeforeClick : midscale);
    this.stage.current.scale({ x: zoomScale, y: zoomScale});
    this.stage.current.position({
      x: this.getCurStagePos().x,
      y: this.getCurStagePos().y
    });
    this.stage.current.batchDraw();
    this.calcNewStageCenterNodePos();
    this.redraw({});
  }

  callConsoleDo(ref){ // window.consoleDo('fullname_pr_id-')
    this.refs[ref].do();
  }

  cancelSpawnedFetchProfiles(){
    this.props.cancelAllSpawnedFetchProfiles();
  }

  releaseQueueFetchedProfilesData(){
    if(this.requestFetchForAllProfiles) return;
    if(typeof(this.props.releaseQueueFetchedProfilesData) === 'function') this.props.releaseQueueFetchedProfilesData();
  }

  exposeForDev(){

    window.fetchResolveAndPopModal = this.testResolveAndPopModal.bind(this);
    window.showModal = this.callShowModal.bind(this);
    window.consoleDo = this.callConsoleDo.bind(this);
    window.getNodeFromNodeObjsWithPrId = getNodeFromNodeObjsWithPrId;
    window.renderStageCanvasToImg = this.renderStageCanvasToImg.bind(this);
    window.callSetPageProfile = this.callSetPageProfile.bind(this);
    window.teleportToNode = this.teleportToNode.bind(this);
    window.resetStagePos = this.resetStagePos.bind(this);
    window.seeLocalState = this.seeLocalState.bind(this);
    window.setFlipPanelOpen = this.setFlipPanelOpen.bind(this);
    window.toggleNavigationalPanel = this.toggleNavigationalPanel.bind(this);
    window.notifyWithAtom = this.notifyWithAtom.bind(this);
    window.resetNavigationState = this.resetNavigationState.bind(this);
    window.seeFloaters = this.seeFloaters.bind(this);
    window.destroyAtomNotification = this.destroyAtomNotification.bind(this);
    window.setTreeVisible = this.setTreeVisible.bind(this);
    window.cancelSpawnedFetchProfiles = this.cancelSpawnedFetchProfiles.bind(this);
    window.releaseQueueFetchedProfilesData = this.releaseQueueFetchedProfilesData.bind(this);
    window.setMaxWidthFullNameRow = this.setMaxWidthFullNameRow.bind(this);
    window.setMaxLineLengthFullNameRow = this.setMaxLineLengthFullNameRow.bind(this);  // For testing purposes
    window.unhighlight = this.unhighlight.bind(this);
    window.highlight = this.highlight.bind(this);
    window.redrawDualPedigreeNode = this.redrawDualPedigreeNode.bind(this);
    window.thisStage = this.stage;
    window.renderStageCanvasToImgForDualPedigree = this.renderStageCanvasToImgForDualPedigree.bind(this);

  }

  exposeForProd(){
    window.callRedrawTree = this.redraw.bind(this);
    window.breakDualPedigreeRender = this.breakDualPedigreeRender.bind(this);
    window.testStagePos = this.testStagePos.bind(this);
    window.enableStageDragging = this.enableStageDragging.bind(this);
    window.showDebugLog = this.showDebugLog.bind(this);
    window.resetStagePos = this.resetStagePos.bind(this);
    window.moveMainStage = this.moveMainStage.bind(this);
    window.forceUpdateCanvas = this.forceUpdateCanvas.bind(this);
    window.releaseForDelayedFetches = this.releaseForDelayedFetches.bind(this);
    window.callRefObj = this.callRefObj.bind(this);
    window.launchHelpCenterWindowinNewTab = this.launchHelpCenterWindowinNewTab.bind(this);
    window.callCreateScrollableModal = this.callCreateScrollableModal.bind(this);
    window.callRemoveScrollableModalWrapper = this.callRemoveScrollableModalWrapper.bind(this);
    window.fetchEveryProfile = this.fetchEveryProfile.bind(this);
    window.refreshGotoList = this.refreshGotoList.bind(this);
    window.resetNavDirectionControls = this.resetNavDirectionControls.bind(this);
    window.allowComponentUpdate = this.allowComponentUpdate.bind(this);
    window.panAndHighlight = this.panAndHighlight.bind(this);
    window.releasePicsQueue = this.releasePicsQueue.bind(this);
    window.checkPicLoadQueue = this.checkPicLoadQueue.bind(this);
    window.countProfiles = this.countProfiles.bind(this);
    window.callshowTreeOverlay = this.showTreeOverlay.bind(this);
    window.callHideTreeOverlay = this.hideTreeOverlay.bind(this);
    window.callShowProgressIndicator = this.showProgressIndicator.bind(this);
    window.callHideProgressIndicator = this.hideProgressIndicator.bind(this);
    window.callSetKeyPressEnabled = this.setKeyPressEnabled.bind(this);
    window.callZoomBackToWhereUserLeftOff = this.zoomBackToWhereUserLeftOff.bind(this);
    window.callToggleFlipPanel = this.toggleFlipPanel.bind(this);
    window.callHookForMessageAlert = this.callHookForMessageAlert.bind(this);
    window.callUnsetFlipData = this.callUnsetFlipData.bind(this);
    window.callUnsetNodeObjProp = this.callUnsetNodeObjProp.bind(this);
    window.callSetReduxCanvasTopHeight = this.setReduxCanvasHeightTop.bind(this);
    window.callUnsetNodeObjPic = this.callUnsetNodeObjPic.bind(this);
    window.callRedraw = this.callRedraw.bind(this);
    window.callReloadCanvasTree = this.reloadCanvasTree.bind(this);
    window.callRefocusFanChart = this.refocusFanChart.bind(this);
    window.callUnsetShowMobileFlipCard = this.unsetShowMobileFlipCard.bind(this);
    window.callVanquishSliderMobileInterface = this.vanquishSliderMobileInterface.bind(this);
    window.callFetchFloaters = this.fetchFloaters.bind(this);
    window.callRefetchProfiles = this.refetchProfiles.bind(this);
    window.callNotifyProfileAdd = this.notifyProfileAdd.bind(this);
    window.callUpdateMatchCounts = this.updateMatchCounts.bind(this); // window.callUpdateMatchCounts(1308,{tm: 2, rm: 1, sm: 1}, true)
    window.callSlideCitationPanel = this.slideCitationPanel.bind(this);
    window.callAdaptStyleForRightPanelPostSlidingCitationToRight = this.adaptStyleForRightPanelPostSlidingCitationToRight.bind(this);
    window.callSlideUpAdditionalInformatioPanel = this.slideUpAdditionalInformatioPanel.bind(this);
    window.callSlideUpAddSourceCitationPanel = this.slideUpAddSourceCitationPanel.bind(this);
    window.callAnimateScrollTopToBottomFileInputContainer = this.animateScrollTopToBottomFileInputContainer.bind(this);
    window.callAddNewFamilyProfileForCitations = this.addNewFamilyProfileForCitations.bind(this);
    window.callElongateChildrenListContainer = this.elongateChildrenListContainer.bind(this);
    window.callDeleteLastPoster = this.deleteLastPoster.bind(this);
  }

  deleteLastPoster(e){
    console.log('deleteLastPoster');
    this.props.postPoster({ action: 'delete' });
  }

  notifyProfileAdd(pr_id){
    // if(this.props.isPedigree || isMobilePhone()) return;
    const node = getNodeFromNodeObjsWithPrId({nodeObjs: this.nodeObjs, prId: pr_id});
    if(typeof(node) === 'undefined' ) return;
    this.props.notifyProfileAdd({node})
  }

  updateMatchCounts( prId, matchData, xShift, yShift, conX, conY ){

    const node = getNodeFromNodeObjsWithPrId({nodeObjs: this.nodeObjs, prId});
    if(typeof(node) === 'undefined' ) return;

    const tmn = matchData.tmn;
    const rmn = matchData.rmn;

    const firstMatchCallback = () => {

      const callback = () => {

        const modalInformMatchFoundCallout = () => {
          window.forceUpdateCanvas('modalInformMatchFoundCallout');
          return !this.state.showProgressIndicator && document.getElementById('modalProfileContent') &&
                 getComputedDomValue({element: document.getElementById('modalProfileContent'), cssProp: 'height'}) > 300;
        }

        const informMatchFoundCalloutContentLoaded = () => {

          const checkIfProfilesLoadedInViewport = () => {
            const { newProfilesObj } = this.gatherNodesToFetchMoreData({all: false,});
            return isEmpty( newProfilesObj );
          }

          const profilesLoaded = () => {
            this.props.updateMatchCounts({node, matchData});
          };

          doWhenReady({argument: '', condition: checkIfProfilesLoadedInViewport, callback: profilesLoaded, attempts: {ongoing:0, end: 99999999}, fromWhere: 'checkIfProfilesLoadedInViewport'})

        }

        doWhenReady({argument: '', condition: modalInformMatchFoundCallout, callback: informMatchFoundCalloutContentLoaded, attempts: {ongoing:0, end: 99999999}, fromWhere: 'updateMatchCounts'})

      }

      if( this.props.isPedigree ){

        if( typeof(tmn) !== 'undefined' ) this.teleportToNodeForPedigree({ hasFirstTreeMatchCountNode: true, callback });
        if( typeof(rmn) !== 'undefined' ) this.teleportToNodeForPedigree({ hasFirstRecordMatchCountNode: true, callback });

      }  else {

        if( typeof(tmn) !== 'undefined' ) this.gotoFocusNode({hasFirstTreeMatchCountNode: true, callback});
        if( typeof(rmn) !== 'undefined' ) this.gotoFocusNode({hasFirstRecordMatchCountNode: true, callback});
      }


    }

    this.props.updateMatchCounts({node, matchData, tmn, rmn, firstMatchCallback});

  }

  releasePicsQueue(){
    this.props.releaseQueueOfFetchedNodeobjPics()
  }

  checkPicLoadQueue(){
    this.props.checkqueuefetchednodeobjpic()
  }

  fetchFloaters(){

    // if( isDevelopment ) return;

    /*
      Following fixes safari bug when floaters are dragged into canvas
     */

    const fromWhere = 'fetchFloaters'
    const logExceptionAndRun = debugStageCurrent(function(stageCurrent) { // exceptions tweak

      stageCurrent.container().style['-webkit-user-select'] = 'none';

    }, fromWhere).bind(this);

    logExceptionAndRun();

    const callbackWhenEverFloatersExist = () => {
      if(!minimal) {
        if( !this.state.showFloaterPanel )this.setShowFloaterPanel(true);
        if( this.decisionChoicesArray.length === 0 ) this.buildChoicesArray();
      }
    }

    const callbackWhenEverFloatersDontExist = () => {
      this.setShowMoveHelp(false);
    }

    setTimeout(() => {
      if(typeof(this.props.fetchFloaters) === 'function') this.props.fetchFloaters({callbackWhenEverFloatersExist, callbackWhenEverFloatersDontExist});
    }, 1000);

  }

  setReduxCanvasHeightTop(top, height){
    // console.log(`{top, height}: `, {top, height});
    if(isMobilePhone()) return
    doWhenReady({
      argument: {},
      condition: ()=>{
        return typeof(this.props.setReduxCanvasHeightTop) === 'function'
      },
      callback: () =>{
        // top = (isMobilePhone() ? top - 70: top - 40);
        // document.getElementById("debugDiv").innerHTML += 'top: ' + top
        this.props.setReduxCanvasHeightTop({top, height});
        setTimeout(() => {
          this.resetMoveHelpPos();
        }, 2000);
      },
      attempts: {ongoing:0, end: 9999999},
      fromWhere: 'setReduxCanvasHeightTop',
    })

  }

  stop_inflight_sagas(){
    this.props.stop_inflight_sagas();
  }

  vanquishSliderMobileInterface(calledFrom){
    // console.log(`calledFrom: `, calledFrom);
    this.unsetShowMobileFlipCard();
    const screenIsOn = `mainFromHome`;
    this.setFlipCardScreenIsOn({screenIsOn});
  }

  callRedraw(callback){
    console.log('callRedraw');
    this.redraw({callback});
  }

  callUnsetFlipData(){
    this.props.unsetFlipData();
  }

  callUnsetNodeObjProp({prId, prIds, all}){// window.callUnsetNodeObjPic({all: true});
    if(typeof(this.props.unsetNodeObjProp) === 'undefined' ){
      console.log('Hermes: this.props.unsetNodeObjProp is not defined');
      return;
    }
    if(typeof(prId) !== 'undefined'){
      var node = getNodeFromNodeObjsWithPrId({nodeObjs:this.nodeObjs, prId, fromWhere: 'unsetFlipDataPermission'});
      this.props.unsetNodeObjProp({node});
    }
    if(typeof(prIds) !== 'undefined'){
      const nodes = prIds.map((prId)=>{
        return getNodeFromNodeObjsWithPrId({nodeObjs:this.nodeObjs, prId});
      })
      this.props.unsetNodeObjProp({nodes});
    }
    if(typeof(all) !== 'undefined'){

      this.props.unsetNodeObjProp({all});
    }
  }

  callUnsetNodeObjPic({prId, all}){ // window.callUnsetNodeObjPic({all: true});
    if(typeof(prId) !== 'undefined') {
      var node = getNodeFromNodeObjsWithPrId({nodeObjs:this.nodeObjs, prId, fromWhere: 'unsetFlipDataPermission'});
    }
    this.props.unsetNodeObjPic({node, all});
  }

  refetchProfiles(prIds){

    if(this.props.chartType === 'fan'){
      window.location.reload();
      return;
    }

    if( dualPedigreeMode ) {

      const tpId = this.props.dualPedigreeObj.tpId;
      const unionId = this.props.dualPedigreeObj.unionId;

      const callReloadCanvasTree = (focusPrId) => {
        this.reloadCanvasTree(focusPrId, { unionId });
      }

      this.props.postPoster({ action: 'reloadPoster', tpId, callReloadCanvasTree});

      return;
    }

    console.count(`refetchProfiles count:`);
    console.log('refetchProfiles: ', JSON.stringify(prIds, null, 2));

    if(typeof(this.props.fetchProfiles) === 'undefined' ) return;

    const prIdsAreInNodeObjs = ({prIds}) => {
      const nodes = prIds.map( (prId) => {
        return getNodeFromNodeObjsWithPrId({nodeObjs:this.nodeObjs, prId, fromWhere: ''});
      }).filter(Boolean);
      return nodes.length;
    }

    if( prIdsAreInNodeObjs({prIds})){
      this.callUnsetNodeObjProp({prIds})
      const newProfilesObj = this.buildRefetchProfilesObj({prIds});
      this.props.fetchProfiles({
        newProfilesObj,
        releaseQueueOfFetchedProfilesData: true,
        callRedraw: () => {
          this.redraw({});
          this.refreshGotoList()
        }
      });
    }

  }

  seeLocalState(){
    console.log(JSON.stringify(this.state, null, 2));
  }

  callHookForMessageAlert({which, type, content, title, duration, okLabel, okCallback, confirmLabel, confirmCallback}){

    /*
      window.callHookForMessageAlert({
        type: 'info',
        content: 'Content',
        title: 'Title',
        duration: 2000,
        confirmLabel: 'Confirm Label',
        okLabel: 'Ok Label',
        okCallback: ()=>{
          console.log('ok');
        },
        confirmCallback: ()=>{
          console.log('confirm');
        }
      });

      window.callHookForMessageAlert({type: 'success', content: 'this is a test', title: 'Profile deleted', duration: 5});
      window.callHookForMessageAlert({type: 'success', content: 'this is a test', title: 'Profile deleted', duration: 5, confirmLabel: 'Undo', confirmCallback: function(){ console.log('test')}});
      window.callHookForMessageAlert({type: 'success', content: 'this is a test', title: 'Notification', duration: 100, confirmLabel: 'Please confirm your email.', confirmCallback: function(){ console.log('test')}});

    */

    if(typeof(which) === 'undefined') which = 'externalCall';

    if(typeof(okCallback) === 'undefined') { okCallback = ()=>{} };

    if(isMobilePhone()){

      if(typeof(confirmLabel) !== 'undefined'){
        // let alertArray = []
        if(typeof(okLabel) === 'undefined') okLabel = 'Ok';
        // alertArray = [
        //   { text: `${confirmLabel}`, onPress: () => confirmCallback() },
        //   { text: `${okLabel}`, onPress: () => okCallback() },
        // ]
        // if(isRtl){
        //     alertArray  = [
        //     { text: `${okLabel}`, onPress: () => okCallback() },
        //     { text: `${confirmLabel}`, onPress: () => confirmCallback() },
        //   ]
        // }
        // Modal.confirm(title, content, alertArray)
        this.setShowConfirmMobile({bool: true, content, mobileOkLabel: okLabel, mobileConfirmLabel: confirmLabel, onMobileConfirm: confirmCallback, onMobileOk: okCallback});
      } else {

        if( content !== '' ) message[type](content, duration);

        this.redraw({});

      }

    } else {

      // const message = 'Notification Title';
      // const description = 'This is the content of the notification. This is the content of the notification. This is the content of the notification.';

      // const type = 'error';
      // const duration = 0;

      // console.log(JSON.stringify({type, content, title, duration, confirmLabel, confirmCallback}, null, 2));


      const onClose = ()=>{
        okCallback();
      }

      this.notifyWithAtom({
        which,
        message: title,
        description: content,
        type,
        duration,
        okLabel,
        confirmLabel,
        confirmCallback,
        onClose});
    }
  }

  setTreeVisible(bool){

    this.setState({
      treeIsVisable: bool
    });
  }

  setResolveVisible(bool){

    this.setState({
      resolveIsVisable: bool
    });
  }

  setShowSwitchOtherIcons(bool){
    this.setState({
      showSwitchOtherIcons: bool
    });
  }

  setShowPrintMobile(bool){

    this.setState({
      showPrintMobile: bool
    });
  }

  setPrintModalVisible(bool){

    this.visitedCount++; this.visited['setPrintModalVisible'] = this.visitedCount;

    if(isMobilePhone()){

      this.hideNotificationModal({});

      setTimeout(() => {
        const screenIsOn = `printCardFromTree`;
        this.setFlipCardScreenIsOn({screenIsOn});
        this.showMobileFlipCard();
      }, 800);

    } else {

      this.hideNotificationModal({});
      let setObj = {
        printModalVisible: bool
      };

      this.setState(setObj);
    }

    if( !bool) this.resetCanvas();
  }

  setInitialPlaceHolders(){
    const placeholderImage_m = new window.Image();
    placeholderImage_m.src = `${imageBasePath}no_photo_m.gif`;
    placeholderImage_m.width = picDim;
    placeholderImage_m.height = picDim;
    placeholderImage_m.onload = () => {

      this.setState({
        placeholderImage_m
       })
    }
    const placeholderImage_f = new window.Image();
    placeholderImage_f.src = `${imageBasePath}no_photo_f.gif`;
    placeholderImage_f.width = picDim;
    placeholderImage_f.height = picDim;
    placeholderImage_f.onload = () => {

      this.setState({
        placeholderImage_f
       })
    }
    const placeholderImage_u = new window.Image();
    placeholderImage_u.src = `${imageBasePath}no_photo_u.gif`;
    placeholderImage_u.width = picDim;
    placeholderImage_u.height = picDim;
    placeholderImage_u.onload = () => {

      this.setState({
        placeholderImage_u
       })
    }
  }

  createImageElementForProfilePic({nodeObj, fromWhere, delayInMilisec}){

    if(isDevelopment) return;

    const image = new window.Image();

    image.crossOrigin = 'anonymous';
    if(nodeObj.img.src.indexOf('?') !== -1){
      image.src = nodeObj.img.src + `&cacheBust=${data.version}`;
    } else {
      image.src = nodeObj.img.src + `?cacheBust=${data.version}`;
    }

    image.onload = () => {

      let width = null;
      let height = null;
      let cropStartX = null;
      let cropStartY = null;
      let sideLength = null;
      let diffPercent = null;
      let orientation = null;

      if( image.width > image.height){

        orientation = 'landscape';
        cropStartX = ((image.width - image.height) / 2);
        cropStartY = 0;
        sideLength = image.height;
        width = image.width;
        height = image.height;

      } else {

        orientation = 'portrait';
        cropStartX = 0;
        cropStartY = ((image.height - image.width) / 3);
        sideLength = image.width;
        width = image.width;
        height = image.height;

        diffPercent = image.height / image.width

      }

      const heightIsDoubleWidth = oddcasesWhereHeightIsDoubleWidth({orientation, width, height});

      const imgObj = {...nodeObj.img, ...{
        image,
        width,
        height,
        cropStartX,
        cropStartY,
        sideLength,
        diffPercent,
        orientation,
        heightIsDoubleWidth,
        imageReset: false,
      }}

      if(typeof(this.props.setNodeObjPic) === 'function'){
        // console.log('img: ', nodeObj.nm);
        this.props.setNodeObjPic({
          node: nodeObj.n,
          imgObj,
          delayInMilisec,
        });
      }

    }
  }

  gatherNodesWithinViewport(){

    const { nodeObjs, viewPortSides } = this.props;
    let nodeObjsInViewPort = {};
    for (let n in nodeObjs) {
      var nodeObj = nodeObjs[n];
      const tempViewportBuffer =  10;
      if( isNodeWithinViewport( { nodeObj, viewPortSides, viewPortBuffer: tempViewportBuffer })) {
        nodeObjsInViewPort[n] = nodeObj;
      };
    }
    return nodeObjsInViewPort;
  }

  switchTreeTo({chart_type}){

    this.setGotoNavTabActive({how: false})
    this.setMapNavTabActive({how: false})
    this.hideProductTour({fromWhere: 'M', withLastStepNotify: true});
    this.unhighlight();
    this.setGotoComponentEnabled(false);

    if(!isDevelopment){
      this.toggleFlipPanel({close: true, from: 'switchTree'});

      this.props.postPreferencesChartType({chart_type});

        const switchTree = () => {
          setTimeout(() => {
            this.unhighlight();
            this.props.postPreferencesChartType({chart_type});
          }, 800);
        }

        if(this.navigationIsUp) {
          this.toggleNavigationalPanel({direction: 'down', switchTree});
        }
        else{
          this.props.postPreferencesChartType({chart_type});
        }

    } else{
      this.setState({
        warnPublic: false,
        prIdForWarning: undefined,
        isPedigreeDev: ( this.state.isPedigreeDev ? false: true)
      });
    }

  }

  switchTree(){

    this.visitedCount++; this.visited['switchTree'] = this.visitedCount;

    this.setGotoNavTabActive({how: false})
    this.setMapNavTabActive({how: false})
    this.hideProductTour({fromWhere: 'M', withLastStepNotify: true});
    this.unhighlight();
    this.setGotoComponentEnabled(false);
    if(!isDevelopment){
      this.toggleFlipPanel({close: true, from: 'switchTree'});
      if(this.props.isPedigree){
        this.props.postPreferencesChartType({chart_type: 'default'});
      } else{
        const switchToDefaultTree = () => {
          setTimeout(() => {
            this.unhighlight();
            this.props.postPreferencesChartType({chart_type: 'horizontal'});
          }, 800);
        }
        if(this.navigationIsUp) {
          this.toggleNavigationalPanel({direction: 'down', switchToDefaultTree});
        }
        else{
          this.props.postPreferencesChartType({chart_type: 'horizontal'});
        }
      }

    } else{
      this.setState({
        warnPublic: false,
        prIdForWarning: undefined,
        isPedigreeDev: ( this.state.isPedigreeDev ? false: true)
      });
    }
  }

  zoomBackToWhereUserLeftOff(){
    this.visitedCount++; this.visited['zoomBackToWhereUserLeftOff'] = this.visitedCount;
    if( dualPedigreeMode || this.props.isFanChart) return;
    const target = (
      typeof(this.curZoomScaleBeforeClick) !== 'undefined' &&
      !isMobilePhone()  &&
      this.curZoomScaleBeforeClick !== 0 ? this.curZoomScaleBeforeClick : exitMobileFlipCardScale);
    this.zoomInOutStepping({target});
  }

  callSetPageProfile(prId, nodeObjs, fromWhere){
    console.log(`fromWhere: `, fromWhere);
    if(typeof(nodeObjs) !== 'undefined'){
      this.nodeObjs = nodeObjs;
    }
    const node = getNodeFromNodeObjsWithPrId({nodeObjs, prId, fromWhere: 'callSetPageProfile'});
    if(typeof(node) === 'undefined'){
      console.log('no such node exist with this prId: ' + prId);
      return false;
    }
    const pageProfilesObj = buildSetPageProfilesObj({nodeObj: this.nodeObjs[node]});
    // console.log('Calling external window.setPageProfile with: ' + JSON.stringify(pageProfilesObj, null, 2));
    if(!isDevelopment){
      // console.log(`window.setPageProfile: `, window.setPageProfile);
      window.setPageProfile(pageProfilesObj);
    }
    return true;
  }

  seeFloaters(){
    console.log(JSON.stringify(this.props.floaters, null, 2));
  }

  getTranslationForLabels(){

    this.translatedLabels = translatedLabels;

    window.translatedLabels = this.translatedLabels;

  }

  addFlipNodeCrumb(node){

    let flipNodeCrumbs = this.state.flipNodeCrumbs;

    flipNodeCrumbs.push(node);


    this.setState({
      flipNodeCrumbs
    });

  }

  removeFlipNodeCrumb(){

    let flipNodeCrumbs = this.state.flipNodeCrumbs;

    const lastNodeIn = flipNodeCrumbs.pop();


    this.setState({
      flipNodeCrumbs
    });

    return lastNodeIn;
  }

  inverseFlipNodeCrumb({dismissOnePanel}){

    let flipNodeCrumbs = this.state.flipNodeCrumbs;

    flipNodeCrumbs = flipNodeCrumbs.reverse();


    this.setState({
      flipNodeCrumbs
    });

    dismissOnePanel();

  }

  resetFlipNodeCrumbs(){


    this.setState({
      flipNodeCrumbs: []
    });

  }

  setNodeForFlipFocus(node){

    this.setState({
      nodeForFlipFocus: node
    });

  }

  unsetNodeForFlipFocus(){

    this.setState({
      nodeForFlipFocus: undefined
    });
  }

  changeFlipNodeCrumbs({doWhatToFlipNodeCrumbs, node}){
    if( doWhatToFlipNodeCrumbs === 'add') this.addFlipNodeCrumb(node);
    if( doWhatToFlipNodeCrumbs === 'remove') this.removeFlipNodeCrumb();
  }

  loadFlip({
    node,
    prId,
    doWhatToFlipNodeCrumbs,
    doAfterNodeIsDefined,
  }){

    this.visitedCount++; this.visited['loadFlip'] = this.visitedCount;

    const callSetNodeObjPic = (nodeObj)=>{
      this.createImageElementForProfilePic({nodeObj, fromWhere: 'desktop toggleFlipPanel'});
    }

    const reLoadFlipPanel = ({node}) =>{
      window.callFlipPanelComponentUpdate({once: false, fromWhere:'reLoadFlipPanel'});
      doAfterNodeIsDefined({node, doWhatToFlipNodeCrumbs})
    }

    this.props.fetchFlipData({
      node,
      pr_id: prId,
      callSetNodeObjPic,
      callback: reLoadFlipPanel,
    });

    this.setState({ nodeForFlipFocus: node });
  }

  nodeIsInTreeView(node){
    return typeof(node) !== 'undefined'
  }

  getEdgeOfTree(){

    const convertObjToArray = (nodeIdArray) => {
      return nodeIdArray.map((nodeId)=>{
        return this.props.nodeObjs[nodeId];
      })
    }

    const nodeIdArray = (Object.keys(this.props.nodeObjs));

    let nodeObjsArray = convertObjToArray(nodeIdArray);

    const leftEdgeOfTree = this.props.edges.get('left');
    const rightEdgeOfTree = this.props.edges.get('right');
    const bottomEdgeOfTree = this.props.edges.get('bottom');
    const farthestLeftNode = this.props.edges.get('leftNode');
    const farthestRightNode = this.props.edges.get('rightNode');

    return { nodeObjsArray, rightEdgeOfTree, leftEdgeOfTree, bottomEdgeOfTree, farthestRightNode, farthestLeftNode };
  }

  prepareGotoNavData({chunkLength}){

    this.visitedCount++; this.visited['prepareGotoNavData'] = this.visitedCount;

    if(typeof(this.props.nodeObjs) === 'undefined' ) return { letters: [], arrayOfColObjsDividedByLetter: []}

    const groupByAlphaOrder = ({nodeObjsArray, letters}) => {
      const groupsOfNodeObjArraysByLetter = [];
      letters.forEach((letter)=>{

        const arrLn = nodeObjsArray.filter((nodeObj)=>{
          return typeof(nodeObj.ln) !== 'undefined' &&  toUpper(nodeObj.ln.charAt(0)) === letter;
        })

        const arrMdn = nodeObjsArray.filter((nodeObj)=>{
          return typeof(nodeObj.mdn) !== 'undefined' && toUpper(nodeObj.mdn.charAt(0)) === letter;
        }).map((nodeObj)=>{
          let {ln, ...rest} = nodeObj;
          return {...rest};
        })

        const arrNm = nodeObjsArray.filter((nodeObj)=>{
          return (nodeObj.ln === '' && typeof(nodeObj.mdn) === 'undefined' && toUpper(nodeObj.nm.charAt(0)) === letter) ||
                 (typeof(nodeObj.ln) === 'undefined' && typeof(nodeObj.mdn) === 'undefined' && toUpper(nodeObj.nm.charAt(0)) === letter);
        })

        let combinedLnMdnNmArr = [...arrLn, ...arrMdn, ...arrNm];

        combinedLnMdnNmArr = combinedLnMdnNmArr.map((nodeObj)=>{
          nodeObj.sortName = ( typeof(nodeObj.ln) !== 'undefined' && toUpper(nodeObj.ln.charAt(0)) === letter ? nodeObj.ln: nodeObj.mdn);
          if(typeof(nodeObj.ln) === 'undefined' && typeof(nodeObj.mdn) === 'undefined' ){
            nodeObj.sortName = nodeObj.nm
          }
          return nodeObj;
        });

        combinedLnMdnNmArr = sortBy(combinedLnMdnNmArr, obj=>obj.sortName + obj.fn)

        if( combinedLnMdnNmArr.length !== 0 ) {
          groupsOfNodeObjArraysByLetter.push(combinedLnMdnNmArr);
        } else {
          groupsOfNodeObjArraysByLetter.push([]);
        }
      });

      return groupsOfNodeObjArraysByLetter;
    }


    const filterOnlyForRealProfilesWithNames = (nodeObjsArray) => {
      return nodeObjsArray.filter((nodeObj)=>{
        return  typeof(nodeObj.nm) !== 'undefined' &&
                nodeObj.nm !== '' &&
                nodeObj.nt !== 'ghost'
      })
    }

    const pruneObject = (nodeObjsArray) => {
      return nodeObjsArray.map((nodeObj)=>{
        return {
          nm: nodeObj.nm,
          n: nodeObj.n,
          pr_id: nodeObj.pr_id,
          fn: nodeObj.fn,
          mn: nodeObj.mn,
          mdn: nodeObj.mdn,
          sfx: nodeObj.sfx,
          ln: ( typeof(nodeObj.ln) === 'undefined' ? '': nodeObj.ln),
        }
      })
    }

    const sortAlphabetically = (nodeObjsArray) =>{
      return sortBy(nodeObjsArray, obj=>obj.ln+ obj.fn);
    }

    const buildInitialArrayOfColObjsDividedByLetter = (letters) => {
      return letters.map((letter)=>{
        return {
          letter,
        }
      })
    }

    const augmentWithNodeObjsArray = ({
      arrayOfColObjsDividedByLetter,
      groupsOfNodeObjArraysByLetter,
    }) => {

      return arrayOfColObjsDividedByLetter.map((oneColObj, idx)=>{

        const nodeObjArrays = groupsOfNodeObjArraysByLetter[idx];

        let numOfPanels = undefined;
        let nodeObjChunks = undefined;
        if( typeof(nodeObjArrays) === 'undefined' ||
            nodeObjArrays.length === 0
        ) {
          numOfPanels = 1;
          nodeObjChunks = [[]]
        } else {
          numOfPanels = ( typeof(chunkLength) !== 'undefined' ? Math.ceil(nodeObjArrays.length / chunkLength): 1);
          nodeObjChunks = breakIdsIntoChunks({
                            ids: groupsOfNodeObjArraysByLetter[idx],
                            chunkLength: ( typeof(chunkLength) !== 'undefined' ? chunkLength: 99999999999),
                          })
        }

        return {
          ...oneColObj,
          nodeObjChunks,
          numOfPanels,
        };
      });
    }

    let { nodeObjsArray, rightEdgeOfTree, leftEdgeOfTree, farthestRightNode, farthestLeftNodeNode } = this.getEdgeOfTree();

    this.farthestRightNode = farthestRightNode;

    this.farthestLeftNodeNode = farthestLeftNodeNode;

    nodeObjsArray = filterOnlyForRealProfilesWithNames(nodeObjsArray);

    nodeObjsArray = pruneObject(nodeObjsArray);

    nodeObjsArray = sortAlphabetically(nodeObjsArray);

    const justFirstCharactersOfLastName = nodeObjsArray.map((nodeObj)=>{
      return toUpper(nodeObj.ln.charAt(0));
    }).filter(Boolean);

    const justFirstCharactersOfFirstName = nodeObjsArray.map((nodeObj)=>{
      return (typeof(nodeObj.mdn) === 'undefined' || nodeObj.mdn === '') &&
              (typeof(nodeObj.ln) === 'undefined' || nodeObj.ln === '') &&
              (typeof(nodeObj.fn) !== 'undefined' && toUpper(nodeObj.fn.charAt(0)));
    }).filter(Boolean);

    const justFirstCharactersOfMaidenName = nodeObjsArray.map((nodeObj)=>{
      return typeof(nodeObj.mdn) !== 'undefined' && toUpper(nodeObj.mdn.charAt(0));
    }).filter(Boolean);


    const combinedCharacters = [...justFirstCharactersOfLastName, ...justFirstCharactersOfFirstName, ...justFirstCharactersOfMaidenName]

    // let uniqueCharactersOfLastName = [...new Set(combinedCharacters)];

    let uniqueCharactersOfLastName = combinedCharacters.filter((v,i,a)=>a.indexOf(v) === i);

    const letters = uniqueCharactersOfLastName.sort();

    const groupsOfNodeObjArraysByLetter = groupByAlphaOrder({nodeObjsArray, letters});

    let arrayOfColObjsDividedByLetter = buildInitialArrayOfColObjsDividedByLetter(letters);

    arrayOfColObjsDividedByLetter = augmentWithNodeObjsArray({
      arrayOfColObjsDividedByLetter,
      groupsOfNodeObjArraysByLetter
    });

    return {
      letters,
      arrayOfColObjsDividedByLetter,
      rightEdgeOfTree,
      leftEdgeOfTree,
    }

  }

  clickforImmediateFamily({
      nodeObj,
      doWhatToFlipNodeCrumbs,
      immediateFamVersion,
      setFetchIsLoading,
     }){

    this.visitedCount++; this.visited['clickforImmediateFamily'] = this.visitedCount;

    if(typeof(nodeObj) === 'undefined'){
      return;
    }

    const prId = nodeObj.prId;

    if(isMobilePhone()){
      return;
    }

    this.setNodeForFlipFocus(undefined);
    if(isMobilePhone()) setFetchIsLoading()

    if(immediateFamVersion === 'addbox'){
      this.toggleFlipPanel({node: nodeObj.n, skipLoadFlipPanel: true})
    }

    const doAfterNodeIsDefined = ({node}) => {
      this.setNodeForFlipFocus(node);
      this.changeFlipNodeCrumbs({doWhatToFlipNodeCrumbs, node})
    }
    const node = getNodeFromNodeObjsWithPrId({nodeObjs: this.props.nodeObjs, prId: nodeObj.prId});
    if( typeof(nodeObj.n) === 'undefined' ||
        !this.nodeIsInTreeView(node) ||
        node.includes('flip')
    ){

        this.loadFlip({
          node: `flip-${prId}`,
          prId: nodeObj.prId,
          doWhatToFlipNodeCrumbs,
          doAfterNodeIsDefined,
        });

        if(!isMobilePhone()) {
          const fullName = nodeObj.fn;
          let posPronoun = undefined;
          switch(nodeObj.g) {
            case 'm':
                posPronoun = 'his';
                break;
            case 'f':
                posPronoun = 'her';
                break;
            case 'u':
                posPronoun = 'his or her';
                break;
            default:
          }

          if( typeof(nodeObj.nvp) !== 'undefined')  posPronoun = 'his or her';

          const devVersion = `${fullName} is hidden in this view.  Click the Tree button to view ${posPronoun} tree.`;
          const content = ( isDevelopment ? devVersion: window.trl(`{name} is hidden in this view.  Click the Tree button to view ${posPronoun} tree.`, null, { name: fullName }));

          this.callHookForMessageAlert({
            type: 'info',
            content,
            title: `${translatedLabels['Information'].translatedLabel}`,
            duration: 5,
          });
        }

    } else {
      if( this.props.chartType === 'fan'){
        this.fanChartComponent.current.highlightFromSidePanel({prId})
      }
      this.loadFlip({
        node,
        prId: nodeObj.prId,
        doWhatToFlipNodeCrumbs,
        doAfterNodeIsDefined,
      });
    }

    if(!isMobilePhone() &&
        typeof(node) !== 'undefined' &&
        node.substring(0, 4) !== 'flip' &&
        this.props.chartType !== 'fan'){
      this.panAndHighlight({node, clickedImmediateFamily: true});
    }

  }

  storePrIdToLocationHistory({prId, userExitsFlipCard}){

    if(userExitsFlipCard) {
      this.allowBashChangeToPan = false;
      setTimeout(() => {
        this.allowBashChangeToPan = true;
      }, 800);
    }

    window.location.hash = prId;
    if(debugDiv && debugLocationHistory) document.getElementById("debugDiv").innerHTML += window.location.hash + '<br/>';

  }

  bindHashChange(){
    addEvent(window, "hashchange", (event) => {
      this.visitedCount++; this.visited['hashchange'] = this.visitedCount;
      const href = window.location.href;
      const hashPrId = href.split('#')[1];

      if(hashPrId === undefined) return;

      const node = getNodeFromNodeObjsWithPrId({nodeObjs: this.nodeObjs, prId: hashPrId});
      if( typeof(node) !== 'undefined' &&
          !node.includes('flip')
      ){
        if(debugDiv && debugLocationHistory) document.getElementById("debugDiv").innerHTML += 'window.history.length: ' + window.history.length + '<br/>';
        if(this.allowBashChangeToPan){
          if(debugDiv && debugLocationHistory) document.getElementById("debugDiv").innerHTML += 'Panning to: ' + hashPrId + '<br/>';
          this.panAnimateToNode({ node, onlyPan: true});
        }
      }
    });
  }

  setGotoComponentEnabled(bool){

    this.setState({gotoComponentEnabled: bool});
  }


  translateUsingLn({nodeObj, showMiddle}){

    const param = {
      last_name: nodeObj.ln,
      first_name: ( typeof(nodeObj.fn) !== 'undefined' ?  nodeObj.fn : ''),
      middle_name: ( typeof(nodeObj.mn) !== 'undefined' && showMiddle ?  nodeObj.mn : ''),
      birth_surname: ( typeof(nodeObj.mdn) !== 'undefined' ?  nodeObj.mdn : ''),
      suffix: ( typeof(nodeObj.sfx) !== 'undefined'?  nodeObj.sfx : ''),
    };

    return ( isDevelopment ? `${nodeObj.ln}, ${nodeObj.fn} ${ typeof(nodeObj.mn) !== 'undefined' ? nodeObj.mn: ''}` :
      window.trl(
        "{last_name}, {first_name} {middle_name} {birth_surname} {suffix}",
        "Name Indexed on Last Name",
        param,
      )
    )
  }

  translateUsingMdn({nodeObj, showMiddle}){

    const param = {
      birth_surname: nodeObj.mdn,
      first_name: ( typeof(nodeObj.fn) !== 'undefined' ?  nodeObj.fn : ''),
      middle_name: ( typeof(nodeObj.mn) !== 'undefined' && showMiddle ?  nodeObj.mn : ''),
      last_name: ( typeof(nodeObj.ln) !== 'undefined'?  nodeObj.ln : ''),
      suffix: ( typeof(nodeObj.sfx) !== 'undefined'?  nodeObj.sfx : ''),
    };

    return ( isDevelopment ? `${nodeObj.mdn}, ${nodeObj.fn} ${ typeof(nodeObj.mn) !== 'undefined' && showMiddle ? nodeObj.mn: ''}` :
      window.trl(
        "{birth_surname}, {first_name} {middle_name} {last_name} {suffix}",
        "Name Indexed on Birth Surname",
        param,
      )
    )
  }

  localStateUpdatesObj = {};
  queueLocalStateUpdates(obj){
    for( let key in obj){
      this.localStateUpdatesObj[key] = obj[key]
    }
  }

  gotoFanChartCenter(){

    this.stage.current.scale({
       x: this.fanChartObj['stageDefaultScale'].x,
       y: this.fanChartObj['stageDefaultScale'].x
     });

    this.stage.current.position(defaultFanChartStagePos);

    this.updateVerticalSliderZoom();

  }

  updateFanChartDefaultScale(){

    this.fanChartObj['stageDefaultScale'] = {
      x: this.stage.current.scaleX(),
      y: this.stage.current.scaleX(),
    };

  }

  bindFanChartStageEvents(){

      this.updateFanChartDefaultScale();

      this.stage.current.container().style.cursor = 'move';
      this.stage.current.draggable(true);
      this.stage.current.container().addEventListener('wheel', (event) => {

        this.fanChartComponent.current.allowComponentUpdate(true);
        this.fanChartComponent.current.setHighlightFrozen(0);
        this.fanChartComponent.current.setHighlight(0);

        event.preventDefault();
        const oldScale = this.stage.current.scaleX();
        const newScale = event.deltaY < 0 ? oldScale * 1.1 : oldScale / 1.1;

        const targetX = this.stage.current.getPointerPosition().x;
        // console.log(`targetX: `, targetX);
        const targetY = this.stage.current.getPointerPosition().y;

        const oldPos = {
          x: targetX / oldScale - this.stage.current.x() / oldScale,
          y: targetY / oldScale - this.stage.current.y() / oldScale,
        };

        if(newScale < minZoom || newScale > maxZoom) return;

        const newPos = {
          x: -(oldPos.x - targetX / newScale) * newScale,
          y: -(oldPos.y - targetY / newScale) * newScale
        };

        this.zoomFanChart({newScale, newPos});
        this.updateVerticalSliderZoom()

      });

      this.stage.current.on('dragstart', (event) => {
        // console.count('dragstart');

        this.setState({
          pedigreeAddboxVisible: false,
        })

        this.fanChartComponent.current.allowComponentUpdate(true);
        this.fanChartComponent.current.setHighlightFrozen(0)
        this.fanChartComponent.current.setHighlight(0);

        this.stageOriginX = event.target.x();
        this.stageOriginY = event.target.y();
      });

      this.stage.current.on('dragend', (event)  => {
        // console.count('dragend');

        // const changeMainStageX = -1 * ( event.target.x() - this.stageOriginX ) * this.stage.current.scaleX();
        // const changeMainStageY = -1 * ( event.target.y() - this.stageOriginY ) * this.stage.current.scaleX();

      });

      this.stage.current.container().addEventListener('mouseover', (e) => {
        if(this.fanChartComponent.current) this.fanChartComponent.current.setHighlight(0);
      })
  }

  zoomFanChart({newScale, newPos}){
    this.stage.current.scale({ x: newScale, y: newScale });
    this.stage.current.position(newPos);
    this.stage.current.batchDraw();

    this.updateVerticalSliderZoom()
  }

  refocusFanChart({prId}){

    if(!isDevelopment) window.Geni.showPageSpinner();

    this.hidePedigreeAddbox();
    setTimeout(() => {

        this.toggleFlipPanel({close: true, from: 'refocusFanChart'});
        this.setPushToHistory();
        this.props.setPrId(prId);

        const callback = ()=>{

          const whenStageIsCurrent = () => {
            return this.stage.current && this.fanChartComponent.current;
          }

          const loadStuff = () => {
            this.gotoFanChartCenter();


             console.log(`%c refocusFanChart`, [
               'color: white',
               'background: green',
               'font-size: 14px',
               'border: 5px solid red',
               'padding: 10px',
               ].join(';'));


            this.callSetPageProfile(prId, this.props.nodeObjs, 'refocusFanChart');
            if(!isDevelopment) window.Geni.hidePageSpinner();
            if( this.state.pushToHistory){
                this.pushToHistoryAfterComponentUpdate();
                this.bindFanChartStageEvents();
                if(!isDevelopment){
                  const node = getNodeFromNodeObjsWithPrId({nodeObjs: this.props.nodeObjs, prId, fromWhere: 'loadStuff'});
                  const pageProfilesObj = buildSetPageProfilesObj({nodeObj: this.props.nodeObjs[node]});
                  window.setPageProfile(pageProfilesObj);
                }
            }
          }

          doWhenReady({argument: '', condition: whenStageIsCurrent, callback: loadStuff, attempts: {ongoing:0, end: 99999999}, fromWhere: ''});

        }

        this.props.fetchTree({callback, fromWhere: 'fanchart refocus'});
    }, 1000);

  }

  refocusFanChart_old({prId}){

    if(!isDevelopment) window.Geni.showPageSpinner();

    const fromWhere = 'refocusFanChart';
    const callFetchTree = ({unionId}) => {

      const callback = ()=>{

        const whenStageIsCurrent = () => {
          return this.stage.current && this.fanChartComponent.current;
        }

        const loadStuff = () => {
          this.gotoFanChartCenter();
          if(!isDevelopment) window.Geni.hidePageSpinner();
          if( this.state.pushToHistory){
              this.pushToHistoryAfterComponentUpdate();
              this.bindFanChartStageEvents();
              if(!isDevelopment){
                const node = getNodeFromNodeObjsWithPrId({nodeObjs: this.props.nodeObjs, prId, fromWhere: 'loadStuff'});
                const pageProfilesObj = buildSetPageProfilesObj({nodeObj: this.props.nodeObjs[node]});
                window.setPageProfile(pageProfilesObj);
              }
          }
        }

        doWhenReady({argument: '', condition: whenStageIsCurrent, callback: loadStuff, attempts: {ongoing:0, end: 99999999}, fromWhere: ''});

      }
      this.props.fetchTree({unionId, callback, fromWhere: 'fanchart'});
    }

    this.toggleFlipPanel({close: true, from: 'refocusFanChart'});
    this.setPushToHistory();
    this.props.setPrId(prId, fromWhere);
    this.props.getUnionIdForFanChart({focusPrId: prId, callFetchTree})
  }

  releaseLocalStateUpdates(){
    console.log(`:=> `, JSON.stringify(this.localStateUpdatesObj, null, 2));

    this.setState(this.localStateUpdatesObj);
    this.localStateUpdatesObj = {};
  }

  launchHelpCenterWindowinNewTab(){
    const href = 'https://help.geni.com/hc/en-us/sections/206535727-Family-Tree';
    window.open(href, '_blank');
  }

  setCustomStylesForTree({newCustomStylesFromPreferences}){

    this.visitedCount++; this.visited['setCustomStylesForTree'] = this.visitedCount;

    let customStyles = undefined;

    if( typeof(newCustomStylesFromPreferences) !== 'undefined'){

      customStyles = newCustomStylesFromPreferences;

    } else {

      if( importCustomStylesFromServer !== null &&  typeof(importCustomStylesFromServer) !== 'undefined'){

        const parsedImportCustomStylesVersions = JSON.parse(importCustomStylesFromServer);

        if( parsedImportCustomStylesVersions !== null &&  typeof(parsedImportCustomStylesVersions) !== 'undefined' ){
          customStyles = parsedImportCustomStylesVersions[1];
        }
      }

      if( isDevelopment && typeof(importCustomStylesFromServer) === 'undefined'){

      }

    }


    let setObj = {};
    let presetCustomObj = presetObj;

    if( customStyles !== null && typeof(customStyles) !== 'undefined'){

      presetCustomObj = { ...presetObj,
        custom: {
          malePresetColor: "",
          femalePresetColor: "",
          unGenderedPresetColor: "",
          stageBackgroundPresetColor: ""
        }
      }

      if(  typeof(customStyles) !== 'undefined' && typeof(customStyles.custom) !== 'undefined'){

        presetCustomObj = { ...presetObj,
          custom: {
            malePresetColor: customStyles.custom.maleCustomPresetColor,
            femalePresetColor: customStyles.custom.femaleCustomPresetColor,
            unGenderedPresetColor: customStyles.custom.unGenderedCustomPresetColor,
            stageBackgroundPresetColor: customStyles.custom.stageBackgroundCustomPresetColor
          }
        }
      }

      if( typeof(presetCustomObj[customStyles.selectedtheme]) !== 'undefined'){
        setObj = { ...setObj, ...{
            selectedtheme: customStyles.selectedtheme,
            maleCustomColor:  presetCustomObj[customStyles.selectedtheme].malePresetColor,
            femaleCustomColor: presetCustomObj[customStyles.selectedtheme].femalePresetColor,
            unGenderedCustomColor: presetCustomObj[customStyles.selectedtheme].unGenderedPresetColor,
            stageBackgroundCustomColor: presetCustomObj[customStyles.selectedtheme].stageBackgroundPresetColor
          }
        }
      }

    }

    const hasFontCustom = () => {
      return customStyles !== null && typeof(customStyles) !== 'undefined' && typeof(customStyles.fontSizeChoice) !== 'undefined'
    }

    if( hasFontCustom() ) {
      setObj = { ...setObj, ...{
        fontSizeChoice: customStyles.fontSizeChoice
      }}
    } else {
      setObj = { ...setObj, ...{
        fontSizeChoice: 'default'
      }}
    }

    setObj = { ...setObj, ...{
      presetCustomObj
    }}


    this.setState(setObj);
  }

  setOptionsForTree({newCustomStylesFromPreferences}){

    this.visitedCount++; this.visited['setOptionsForTree'] = this.visitedCount;

    let customStyles = undefined;

    if( typeof(newCustomStylesFromPreferences) !== 'undefined'){

      customStyles = newCustomStylesFromPreferences;

    } else {

      if( importCustomStylesFromServer !== null &&  typeof(importCustomStylesFromServer) !== 'undefined'){

        const parsedImportCustomStylesVersions = JSON.parse(importCustomStylesFromServer);

        if( parsedImportCustomStylesVersions !== null &&  typeof(parsedImportCustomStylesVersions) !== 'undefined' ){
          customStyles = parsedImportCustomStylesVersions[1];
        }
      }

    }

    let setObj = {};

    if( customStyles !== null &&
        typeof(customStyles) !== 'undefined' &&
        typeof(customStyles.options) !== 'undefined'){

        setObj = { ...setObj, ...{
            showCardPhotos: customStyles.options.showCardPhotos,
            showCardEditIcon: customStyles.options.showCardEditIcon,
            showCardEmailInvite: customStyles.options.showCardEmailInvite
          }
        }

    }

    this.setState(setObj);
  }

  getRenderNotificationModal(){

      if(minimal) return null;

      let notification = undefined;

      const showFirstMatchNotificationModal = () => {
        notification = 'firstTreeMatchCount';
        return typeof(this.props.firstTreeMatchCountNode) !== 'undefined' && this.state.firstTreeMatchCountNotify && typeof(this.nodeObjs) !== 'undefined'  && typeof(this.stage) !== 'undefined'
      }

      const showFirstRecordNotificationModal = () => {
        notification = 'firstRecordMatchCount';
        return typeof(this.props.firstRecordMatchCountNode) !== 'undefined' && this.state.firstRecordMatchCountNotify && typeof(this.nodeObjs) !== 'undefined'  && typeof(this.stage) !== 'undefined'
      }

      const showWarnPublicOfProfilleNotification = () => {
        notification = 'publicWarning';
        const showIt = this.state.warnPublic && this.state.treeIsVisable;
        return showIt;
      }

      return (

            showWarnPublicOfProfilleNotification() ||
            showFirstMatchNotificationModal() ||
            showFirstRecordNotificationModal()

            ?

            <NotificationModal
              canvasWidth={this.props.canvasWidth}
              canvasHeight={this.props.canvasHeight}
              translatedLabels={this.translatedLabels}
              postPreferences={this.props.postPreferences}
              nodeObjPosForInformModal={this.state.nodeObjPosForInformModal}
              prIdForWarning={this.state.prIdForWarning}
              firstTreeMatchCountNode={this.props.firstTreeMatchCountNode}
              firstRecordMatchCountNode={this.props.firstRecordMatchCountNode}
              nodeObjs={this.nodeObjs}
              notification={notification}
              isPedigree={this.props.isPedigree}
              scaleX={this.stage.current.scaleX()}
              hideNotificationModal={this.hideNotificationModal.bind(this)}
              zoomAnimateToNode={this.zoomAnimateToNode.bind(this)}
              gotoFocusNode={this.gotoFocusNode.bind(this)}
              zoomAnimateCenterPedigree={this.zoomAnimateCenterPedigree.bind(this)}
              teleportToNode={this.teleportToNode.bind(this)}
              showMatchBubbleFor={this.showMatchBubbleFor.bind(this)}
              hideMatchBubble={this.hideMatchBubble.bind(this)}
            />

            :

            null
      )
    }

  closeGeniForms(){
    if(typeof(window.closeAddNode) !== 'undefined' ) window.closeAddNode();
    if(window.editCard) window.closeEditCard("1");
    if(typeof(window.$j) !== 'undefined') window.$j('.add-cancel').click();
  }

  showDebugLog(fromWhere){

    this.debugOrder++;
    this.debugObj['moveOperationWithCtrlKeyDnActivated'] = {order: this.debugOrder, 'state': this.state.moveOperationWithCtrlKeyDnActivated}
    this.debugOrder++;
    this.debugObj['activateDesignateDragOrDropTarget'] = {order: this.debugOrder, 'state': this.state.activateDesignateDragOrDropTarget}


     // console.log(`: `, JSON.stringify(this.debugObj, null, 2));
     if(typeof(window.logJSObject) === 'function') window.logJSObject(`Triggered from: ${fromWhere}`, this.debugObj);

  }

}

export default Base;


